// ** React Imports
import { createContext, useCallback, useMemo, useState, useContext } from 'react'

import {
  templateUrl,
  sendMailToMailpit,
  replaceMergeTags,
  getTemplatesFilter,
  externalIdUrl,
  templateChannelIgnoredValidationsUrl
} from 'src/configs/api'
import { useAuth } from 'src/hooks/useAuth'
import { useAPI } from 'src/utils/api'
import PropTypes from 'prop-types'
import { generateSubjectUrl, getTags, generateImageAIUrl } from 'src/configs/api'
import { AuthContext } from './AuthContext'
import { useToast } from 'src/@core/components/custom-Toast/customToast'
const defaultProvider = {
  selectedTemplateChannelTab: 'email',
  setSelectedTemplateChannelTab: () => null,
  templateDirection: '',
  setTemplateDirection: () => null,
  templateListData: [],
  setTemplateListData: () => null,
  vendorListData: [],
  setVendorListData: () => null,
  isApiIntegrated: false,
  setIsApiIntegrated: () => null,
  publishedTemplateList: [],
  setPublishedTemplateList: () => null,
  templateName: '',
  setTemplateName: () => null,
  templateDescription: '',
  setTemplateDescription: () => null,
  templateLanguage: 'en',
  setTemplateLanguage: () => null,
  tags: [],
  setTags: () => null,
  selectedChannels: [],
  setSelectedChannels: () => null,
  isTemplateSetupModified: false,
  setIsTemplateSetupModified: () => null,
  selectedTemplate: null,
  setSelectedTemplate: () => null,
  editorID: 2,
  setEditorID: () => null,
  emailEditorInitialized: false,
  setEmailEditorInitialized: () => null,
  selectedTemplateId: '',
  setSelectedTemplateId: () => null,
  externalTemplateId: '',
  setExternalTemplateId: () => null,
  externalTemplateKey: '',
  setExternalTemplateKey: () => null,
  whatsappExternalTemplateId: '',
  setWhatsappExternalTemplateId: () => null,
  smsExternalTemplateId: '',
  setSmsExternalTemplateId: () => null,
  rcsExternalTemplateId: '',
  setRcsExternalTemplateId: () => null,
  whatsappExternalTemplateKey: '',
  setWhatsappExternalTemplateKey: () => null,
  smsExternalTemplateKey: '',
  setSmsExternalTemplateKey: () => null,
  rcsExternalTemplateKey: '',
  setRcsExternalTemplateKey: () => null,
  enableEmail: false,
  setEnableEmail: () => null,
  enableWhatsapp: false,
  setEnableWhatsapp: () => null,
  enableRCS: false,
  setEnableRCS: () => null,
  enableSms: false,
  setEnableSms: () => null,
  isTemplateChannelsModified: false,
  setIsTemplateChannelsModified: () => null,
  updatedEnabledChannels: [],
  setUpdatedEnabledChannels: () => null,
  updatedDisabledChannels: [],
  setUpdatedDisabledChannels: () => null,
  previousUserChannels: [],
  setPreviousUserChannels: () => null,
  selectedChannelId: '',
  setSelectedChannelId: () => null,
  selectedTemplateChannelId: '',
  setSelectedTemplateChannelId: () => null,
  emailTemplateChannelId: '',
  setEmailTemplateChannelId: () => null,
  whatsappTemplateChannelId: '',
  setWhatsappTemplateChannelId: () => null,
  rcsTemplateChannelId: '',
  setRcsTemplateChannelId: () => null,
  smsTemplateChannelId: '',
  setSmsTemplateChannelId: () => null,
  emailChannelId: '',
  setEmailChannelId: () => null,
  whatsappChannelId: '',
  setWhatsappChannelId: () => null,
  rcsChannelId: '',
  setRcsChannelId: () => null,
  smsChannelId: '',
  setSmsChannelId: () => null,
  smsValue: '',
  setSmsValue: () => null,
  smsFallbackTextforRCS: '',
  setSmsFallbackTextforRCS: () => null,
  emailValue: '',
  setEmailValue: () => null,
  whatsappValue: '',
  setWhatsappValue: () => null,
  rcsValue: '',
  setRCSValue: () => null,
  rcstemplateType: 'text',
  setRCSTemplateType: () => null,
  activeChannelStep: 0,
  setActiveChannelStep: () => null,
  htmlValue: '',
  setHtmlValue: () => null,
  beeValue: '',
  setBeeValue: () => null,
  isEmailContentModified: false,
  setIsRCSContentModified: () => null,
  isRCSContentModified: false,
  setIsEmailContentModified: () => null,
  isWhatsappContentModified: false,
  setIsWhatsappContentModified: () => null,
  isSmsContentModified: false,
  setIsSmsContentModified: () => null,
  mailpitID: '',
  setMailpitID: () => null,
  whatsappContentDescription: '',
  setWhatsappContentDescription: () => null,
  smsContentDescription: '',
  setSmsContentDescription: () => null,
  beefreeJSON: '',
  setBeefreeJSON: () => null,
  archivedTemplateData: [],
  setArchivedTemplateData: () => null,
  previewEmailData: '',
  setPreviewEmailData: () => null,
  previewWhatsappData: '',
  setPreviewWhatsappData: () => null,
  previewSmsData: '',
  setPreviewSmsData: () => null,
  searchTerm: '',
  setSearchTerm: () => null,
  totalTemplates: 0,
  setTotalTemplates: () => null,
  tagsData: [],
  setTagsData: () => null,
  emailTemplateContentId: '',
  setEmailTemplateContentId: () => null,
  whatsappTemplateContentId: '',
  setWhatsappTemplateContentId: () => null,
  smsTemplateContentId: '',
  setSmsTemplateContentId: () => null,
  rcsTemplateContentId: '',
  setRcsTemplateContentId: () => null,
  templateValidationCheckList: [],
  setTemplateValidationCheckList: () => null,
  templateCategory: 'marketing',
  setTemplateCategory: () => null,
  isTemplateValid: false,
  setIsTemplateValid: () => null,
  isProcessing: false,
  setIsProcessing: () => null,
  isNextStepLoading: false,
  setIsNextStepLoading: () => null,
  selectedPreviewTab: '',
  setSelectedPreviewTab: () => null,

  generateAIImage: () => null,

  activePreviewStep: 0,
  setActivePreviewStep: () => null,
  subjectLine: '',
  setSubjectLine: () => null,
  preheaderText: '',
  setPreheaderText: () => null,
  templatesTagList: [],
  setTemplatesTagList: () => null,
  customKeyValuePairs: [],
  setCustomKeyValuePairs: () => null,
  attachments: [],
  setAttachments: () => null,
  templatesChannelFilterList: [],
  setTemplatesChannelFilterList: () => null,
  templatesStatusFilterList: [],
  setTemplatesStatusFilterList: () => null,
  standaloneRcsCard: {},
  setStandaloneRcsCard: () => null,
  whatsappHeaderFile: '',
  setWhatsappHeaderFile: () => null,
  isFooterOpen: false,
  setIsFooterOpen: () => null,
  selectedVendorData: {},
  setSelectedVendorData: () => null,
  cards: [
    {
      id: 1,
      headerType: 'none',
      headerMediaFile: null,
      titleText: '',
      bodyText: '',
      actionButtons: [],
      cardOrientation: 'vertical',
      mediaHeight: 'short'
    }
  ],
  setCards: () => null,
  whatsappCards: [
    {
      id: 1,
      headerType: 'none',
      headerContent: '',
      headerMediaFile: null,
      bodyText: '',
      footerText: '',
      actionButtons: []
    }
  ],
  setWhatsappCards: () => null,
  cardType: 'standard',
  setCardType: () => null,
  textActionButtons: [],
  setTextActionButtons: () => null,
  whatsappActionButtons: [],
  setWhatsappActionButtons: () => null,

  templateFilterList: [],
  setTemplateFilterList: () => null,
  templateOtherFilterList: [],
  setTemplateOtherFilterList: () => null,
  hasTagFilter: false,
  setHasTagFilter: () => null,

  apiId: {
    sms: {
      layoutGroupId: '',
      unitId: '',
      componentId: ''
    },

    rcs: {
      text: {
        groupId: '', // was layoutGroupId
        unitId: '',
        messageComponentId: '',
        actionButtonComponentIds: [],
        fallbackComponentId: ''
      },
      standalone: {
        groupId: '', // layoutGroup.groupId of the standalone card
        unitId: '', // contentUnit.unitId of the standalone card
        mediaComponentId: '', // contentId of rcs_media
        titleComponentId: '', // contentId of rcs_card_title
        descComponentId: '', // contentId of rcs_card_description
        actionButtonIds: [], // array of contentIds of all action buttons
        fallback: {
          // fallback SMS block
          groupId: '', // fallback layoutGroupId
          unitId: '', // fallback unitId
          componentId: '' // fallback contentId
        }
      },

      carousel: {
        groupId: '', // 🔁 rename from layoutGroupId → groupId (important)
        cardUnits: [
          {
            unitId: '',
            mediaId: '',
            titleId: '',
            descId: '',
            actionIds: []
          }
        ],
        fallback: {
          groupId: '',
          unitId: '',
          componentId: ''
        }
      }
    },

    whatsapp: {
      standard: {
        // HEADER
        headerGroupId: '',
        headerUnitId: '',
        headerId: '',

        // BODY
        bodyGroupId: '',
        bodyUnitId: '',
        bodyId: '',

        // FOOTER (TEXT)
        footerGroupId: '',
        footerUnitId: '',
        footerId: '',

        // ACTION BUTTONS (Footer 2)
        actionGroupId: '', // groupId for the action footer group
        actionUnitId: '', // unitId for the action group
        actionButtonIds: [] // array of contentIds for each button
      },
      carousel: {
        // BODY BLOCK
        bodyGroupId: '', // layoutGroupId for body section
        bodyUnitId: '', // unitId of the body content
        bodyComponentId: '', // contentId for the body text

        // CARDS BLOCK
        cardsGroupId: '', // layoutGroupId for card list

        cards: [
          // Repeat for dynamic cards
          // This is ONE card structure:
          {
            unitId: '', // card unit ID
            headerId: '', // header component contentId
            bodyId: '', // body component contentId
            actionIds: [] // array of contentIds for actions
          }
        ]
      }

      // carousel: {
      //   body: {
      //     layoutGroupId: "",
      //     unitId: "",
      //     componentId: "" // whatsapp_body
      //   },

      //   cards: [
      //     // each card entry like:
      //     // {
      //     //   layoutGroupId: "",
      //     //   unitId: "",
      //     //   headerId: "",
      //     //   bodyId: "",
      //     //   footerId: "",
      //     //   actionIds: []
      //     // }
      //   ]
      // }
    },

    email: {
      subject: {
        layoutGroupId: '',
        unitId: '',
        componentId: ''
      },
      preheader: {
        layoutGroupId: '',
        unitId: '',
        componentId: ''
      },
      customheader: {
        groupId: '',
        unitId: '',
        componentIds: []
      },
      attachments: {
        groupId: '',
        unitId: '',
        componentId: ''
      },
      body: {
        layoutGroupId: '',
        unitId: '',
        componentId: ''
      }
    }
  },

  setApiId: () => null,
  templateActiveStep: 0,
  setTemplateActiveStep: () => null
}

const TemplateContext = createContext(defaultProvider)

const TemplateProvider = ({ children }) => {
  const [selectedTemplateChannelTab, setSelectedTemplateChannelTab] = useState(
    defaultProvider.selectedTemplateChannelTab
  )

  const [templateDirection, setTemplateDirection] = useState(defaultProvider.templateDirection)

  const [editorID, setEditorID] = useState(defaultProvider.editorID)

  const [searchTerm, setSearchTerm] = useState(defaultProvider.searchTerm)

  const [templateListData, setTemplateListData] = useState(defaultProvider.templateListData)

  const [vendorListData, setVendorListData] = useState(defaultProvider.vendorListData)

  const [isApiIntegrated, setIsApiIntegrated] = useState(defaultProvider.isApiIntegrated)

  const [publishedTemplateList, setPublishedTemplateList] = useState(defaultProvider.publishedTemplateList)

  const [templateName, setTemplateName] = useState(defaultProvider.templateName)

  const [templateDescription, setTemplateDescription] = useState(defaultProvider.templateDescription)

  const [templateLanguage, setTemplateLanguage] = useState(defaultProvider.templateLanguage || 'en')

  const [tags, setTags] = useState(defaultProvider.tags)

  const [enableEmail, setEnableEmail] = useState(defaultProvider.enableEmail)

  const [enableWhatsapp, setEnableWhatsapp] = useState(defaultProvider.enableWhatsapp)

  const [enableRCS, setEnableRCS] = useState(defaultProvider.enableRCS)

  const [enableSms, setEnableSms] = useState(defaultProvider.enableSms)

  const [smsValue, setSmsValue] = useState(defaultProvider.smsValue)

  const [smsFallbackTextforRCS, setSmsFallbackTextforRCS] = useState(defaultProvider.smsFallbackTextforRCS)

  const [emailValue, setEmailValue] = useState(defaultProvider.emailValue)

  const [activeChannelStep, setActiveChannelStep] = useState(defaultProvider.activeChannelStep)

  const [whatsappValue, setWhatsappValue] = useState(defaultProvider.whatsappValue)

  const [selectedPreviewTab, setSelectedPreviewTab] = useState(defaultProvider.selectedPreviewTab)

  const [activePreviewStep, setActivePreviewStep] = useState(defaultProvider.activePreviewStep)

  // WhatsApp structured builder state
  const [templateCategory, setTemplateCategory] = useState(defaultProvider.templateCategory || 'marketing')
  const [whatsappSelectedVendor, setWhatsappSelectedVendor] = useState(null)
  const [rcsSelectedVendor, setRcsSelectedVendor] = useState(null)
  const [whatsappHeaderType, setWhatsappHeaderType] = useState(defaultProvider.whatsappHeaderType || 'none')
  const [whatsappHeaderText, setWhatsappHeaderText] = useState(defaultProvider.whatsappHeaderText || '')
  const [whatsappHeaderLink, setWhatsappHeaderLink] = useState(defaultProvider.whatsappHeaderLink || '')
  const [whatsappHeaderMediaFromPC, setWhatsappHeaderMediaFromPC] = useState(
    defaultProvider.whatsappHeaderMediaFromPC || ''
  )
  const [whatsappHeaderFile, setWhatsappHeaderFile] = useState(defaultProvider.whatsappHeaderFile || '')
  const [whatsappHeaderMediaHeaderId, setWhatsappHeaderMediaHeaderId] = useState(
    defaultProvider.whatsappHeaderMediaHeaderId || ''
  )
  const [whatsappFooterText, setWhatsappFooterText] = useState(defaultProvider.whatsappFooterText || '')
  const [whatsappButtons, setWhatsappButtons] = useState(defaultProvider.whatsappButtons || [])

  const [rcsValue, setRCSValue] = useState(defaultProvider.rcsValue)

  const [selectedTemplateId, setSelectedTemplateId] = useState(defaultProvider.selectedTemplateId)

  const [externalTemplateId, setExternalTemplateId] = useState(defaultProvider.externalTemplateId)
  const [externalTemplateKey, setExternalTemplateKey] = useState(defaultProvider.externalTemplateKey)

  const [whatsappExternalTemplateId, setWhatsappExternalTemplateId] = useState(
    defaultProvider.whatsappExternalTemplateId
  )
  const [smsExternalTemplateId, setSmsExternalTemplateId] = useState(defaultProvider.smsExternalTemplateId)
  const [rcsExternalTemplateId, setRcsExternalTemplateId] = useState(defaultProvider.rcsExternalTemplateId)

  const [whatsappExternalTemplateKey, setWhatsappExternalTemplateKey] = useState(
    defaultProvider.whatsappExternalTemplateKey
  )
  const [smsExternalTemplateKey, setSmsExternalTemplateKey] = useState(defaultProvider.smsExternalTemplateKey)
  const [rcsExternalTemplateKey, setRcsExternalTemplateKey] = useState(defaultProvider.rcsExternalTemplateKey)

  const [mailpitID, setMailpitID] = useState(defaultProvider.mailpitID)

  const [selectedChannels, setSelectedChannels] = useState(defaultProvider.selectedChannels)

  const [templatesTagList, setTemplatesTagList] = useState(defaultProvider.templatesTagList)
  const [templatesChannelFilterList, setTemplatesChannelFilterList] = useState(
    defaultProvider.templatesChannelFilterList
  )
  const [customKeyValuePairs, setCustomKeyValuePairs] = useState(defaultProvider.customKeyValuePairs)
  const [attachments, setAttachments] = useState(defaultProvider.attachments)
  const [templatesStatusFilterList, setTemplatesStatusFilterList] = useState(defaultProvider.templatesStatusFilterList)

  const [cards, setCards] = useState(defaultProvider.cards)

  const [textActionButtons, setTextActionButtons] = useState(defaultProvider.textActionButtons)

  const [whatsappActionButtons, setWhatsappActionButtons] = useState(defaultProvider.whatsappActionButtons)

  const [whatsappCards, setWhatsappCards] = useState(defaultProvider.whatsappCards)

  const [previousUserChannels, setPreviousUserChannels] = useState(defaultProvider.previousUserChannels)

  const [selectedTemplate, setSelectedTemplate] = useState(defaultProvider.selectedTemplate)

  const [beefreeJSON, setBeefreeJSON] = useState(defaultProvider.beefreeJSON)

  const [isTemplateSetupModified, setIsTemplateSetupModified] = useState(defaultProvider.isTemplateSetupModified)

  // Inline save status (replaces the toast for step-0 template save) — { type: 'success'|'error', message } | null
  const [templateSaveStatus, setTemplateSaveStatus] = useState(null)

  const [isTemplateChannelsModified, setIsTemplateChannelsModified] = useState(
    defaultProvider.isTemplateChannelsModified
  )

  const [emailTemplateChannelId, setEmailTemplateChannelId] = useState(defaultProvider.emailTemplateChannelId)

  const [whatsappTemplateChannelId, setWhatsappTemplateChannelId] = useState(defaultProvider.whatsappTemplateChannelId)

  const [rcsTemplateChannelId, setRcsTemplateChannelId] = useState(defaultProvider.rcsTemplateChannelId)

  const [smsTemplateChannelId, setSmsTemplateChannelId] = useState(defaultProvider.smsTemplateChannelId)

  const [emailChannelId, setEmailChannelId] = useState(defaultProvider.emailChannelId)

  const [whatsappChannelId, setWhatsappChannelId] = useState(defaultProvider.whatsappChannelId)

  const [rcsChannelId, setRcsChannelId] = useState(defaultProvider.rcsChannelId)

  const [smsChannelId, setSmsChannelId] = useState(defaultProvider.smsChannelId)

  const [selectedChannelId, setSelectedChannelId] = useState(defaultProvider.selectedChannelId)

  const [selectedTemplateChannelId, setSelectedTemplateChannelId] = useState(defaultProvider.selectedTemplateChannelId)

  const [updatedEnabledChannels, setUpdatedEnabledChannels] = useState(defaultProvider.updatedEnabledChannels)

  const [updatedDisabledChannels, setUpdatedDisabledChannels] = useState(defaultProvider.updatedDisabledChannels)

  const [htmlValue, setHtmlValue] = useState(defaultProvider.htmlValue)

  const [beeValue, setBeeValue] = useState(defaultProvider.beeValue)

  const [archivedTemplateData, setArchivedTemplateData] = useState(defaultProvider.archivedTemplateData)

  const [, setWhatsappContentDescription] = useState(defaultProvider.whatsappContentDescription)

  const [previewEmailData, setPreviewEmailData] = useState(defaultProvider.previewEmailData)

  const [previewWhatsappData, setPreviewWhatsappData] = useState(defaultProvider.previewWhatsappData)

  const [previewSmsData, setPreviewSmsData] = useState(defaultProvider.previewSmsData)

  const [smsContentDescription, setSmsContentDescription] = useState(defaultProvider.smsContentDescription)

  const [isEmailContentModified, setIsEmailContentModified] = useState(defaultProvider.isEmailContentModified)

  const [isRCSContentModified, setIsRCSContentModified] = useState(defaultProvider.isRCSContentModified)

  const [isWhatsappContentModified, setIsWhatsappContentModified] = useState(defaultProvider.isWhatsappContentModified)

  const [isSmsContentModified, setIsSmsContentModified] = useState(defaultProvider.isSmsContentModified)

  const [totalTemplates, setTotalTemplates] = useState(defaultProvider.totalTemplates)

  const [tagsData, setTagsData] = useState(defaultProvider.tagsData)

  const [emailTemplateContentId, setEmailTemplateContentId] = useState(defaultProvider.emailTemplateContentId)

  const [whatsappTemplateContentId, setWhatsappTemplateContentId] = useState(defaultProvider.whatsappTemplateContentId)

  const [, setRcsTemplateContentId] = useState(defaultProvider.rcsTemplateContentId)

  const [smsTemplateContentId, setSmsTemplateContentId] = useState(defaultProvider.smsTemplateContentId)

  const [templateValidationCheckList, setTemplateValidationCheckList] = useState(
    defaultProvider.templateValidationCheckList
  )

  const [isTemplateValid, setIsTemplateValid] = useState(defaultProvider.isTemplateValid)

  const [isFooterOpen, setIsFooterOpen] = useState(defaultProvider.isFooterOpen)

  const [isProcessing, setIsProcessing] = useState(defaultProvider.isProcessing)

  const [isNextStepLoading, setIsNextStepLoading] = useState(defaultProvider.isNextStepLoading)

  const [apiId, setApiId] = useState(defaultProvider.apiId)
  const [subjectLine, setSubjectLine] = useState(defaultProvider.subjectLine)
  const [preheaderText, setPreheaderText] = useState(defaultProvider.preheaderText)
  const [rcstemplateType, setRCSTemplateType] = useState(defaultProvider.rcstemplateType)
  const [selectedVendorData, setSelectedVendorData] = useState(defaultProvider.selectedVendorData)
  const [standaloneRcsCard, setStandaloneRcsCard] = useState(defaultProvider.standaloneRcsCard)
  const [templateFilterList, setTemplateFilterList] = useState(defaultProvider.templateFilterList)
  const [templateOtherFilterList, setTemplateOtherFilterList] = useState(defaultProvider.templateOtherFilterList)
  const [hasTagFilter, setHasTagFilter] = useState(defaultProvider.hasTagFilter)
  const { replyEmail } = useContext(AuthContext)

  const api = useAPI()
  const { showSuccess, showError, showWarning } = useToast()

  const [cardType, setCardType] = useState(defaultProvider.cardType)
  const [templateActiveStep, setTemplateActiveStep] = useState(0)

  const getActionButtonPayload = useCallback(btn => {
    return {
      type: btn.type,
      url: btn.url,
      label: btn.label
    }
  }, [])

  const getRcsTextPayload = () => {
    const rcsIds = apiId?.rcs?.text || {}
    const isUpdate = !!rcsIds.groupId && !!rcsIds.unitId && !!rcsIds.messageComponentId

    // -----------------------------
    // Fallback block builder
    // -----------------------------
    const getRcsSmsFallbackBlock = fallbackText => {
      const fallbackId = rcsIds.fallbackComponentId
      const isFallbackUpdate = !!fallbackId

      return {
        ...(isFallbackUpdate && { groupId: rcsIds.fallbackGroupId }),
        layoutType: 'BLOCK',
        configuration: {},
        contentUnits: [
          {
            ...(isFallbackUpdate && { unitId: rcsIds.fallbackUnitId }),
            unitName: 'Fallback',
            components: [
              {
                ...(isFallbackUpdate && { contentId: fallbackId }),
                componentKey: 'rcs_fallback_sms_message',
                componentCategory: 'BODY',
                dataType: 'TEXT',
                translations: {
                  en: fallbackText
                }
              }
            ]
          }
        ]
      }
    }

    // -----------------------------
    // Main message content block
    // -----------------------------
    const messageBlock = {
      layoutType: 'BLOCK',
      ...(isUpdate && { groupId: rcsIds.groupId }),
      configuration: {},
      contentUnits: [
        {
          ...(isUpdate && { unitId: rcsIds.unitId }),
          unitName: 'Message Content',
          components: [
            // Main message text
            {
              ...(isUpdate && { contentId: rcsIds.messageComponentId }),
              componentKey: 'rcs_message',
              componentCategory: 'BODY',
              dataType: 'TEXT',
              translations: { en: rcsValue }
            },

            // Action buttons
            ...textActionButtons.map(btn => {
              const isExistingButton = !!btn.id && !btn.isNew

              // Quick reply
              if (btn.type === 'quick_reply') {
                return {
                  ...(isExistingButton && { contentId: btn.id }),
                  componentKey: 'rcs_action_button',
                  componentCategory: 'FOOTER',
                  dataType: 'JSON',
                  translations: {
                    en: {
                      type: 'quick_reply',
                      title: btn.text || 'reply',
                      payload: btn.quickReplies?.map(q => q.text) || []
                    }
                  }
                }
              }

              // Normal button
              return {
                ...(isExistingButton && { contentId: btn.id }),
                componentKey: 'rcs_action_button',
                componentCategory: 'FOOTER',
                dataType: 'JSON',
                translations: {
                  en:
                    btn.type === 'quick_reply'
                      ? {
                          type: 'quick_reply',
                          title: 'reply',
                          payload: btn.quickReplies?.map(q => q.text)
                        }
                      : btn.type === 'coupon_code'
                        ? {
                            type: btn.type,
                            title: 'coupon',
                            payload: btn.value
                          }
                        : {
                            type: btn.type,
                            title: btn.text,
                            payload: btn.value
                          }
                }
                // translations: {
                //   en: {
                //     type: btn.type,
                //     title: btn.text,
                //     payload: btn.value
                //   }
                // }
              }
            })
          ]
        }
      ]
    }

    // -----------------------------
    // Build full payload
    // -----------------------------
    const layoutGroups = [messageBlock]

    if (smsFallbackTextforRCS?.trim()) {
      layoutGroups.push(getRcsSmsFallbackBlock(smsFallbackTextforRCS))
    }

    return {
      configuration: {
        template_type: 'text_message',
        ...(rcsSelectedVendor && { selected_vendor: rcsSelectedVendor }),
        template_source: 'cxp'
      },
      layoutGroups
    }
  }
  const getRcsStandalonePayload = () => {
    const standaloneIds = apiId?.rcs?.standalone || {}
    const isUpdate = !!standaloneIds.groupId

    return {
      configuration: {
        template_type: 'rich_card_stand_alone',
        ...(rcsSelectedVendor && { selected_vendor: rcsSelectedVendor }),
        template_source: 'cxp'
      },
      layoutGroups: [
        {
          ...(isUpdate && { groupId: standaloneIds.groupId }),
          layoutType: 'BLOCK',
          configuration: {
            card_orientation: cards[0].cardOrientation,
            media_height: cards[0].mediaHeight
          },
          contentUnits: [
            {
              ...(isUpdate && { unitId: standaloneIds.unitId }),
              unitName: 'Message Content',
              components: [
                // MEDIA
                {
                  ...(isUpdate && standaloneIds.mediaComponentId && { contentId: standaloneIds.mediaComponentId }),
                  componentKey: 'rcs_media',
                  componentCategory: 'BODY',
                  dataType: 'JSON',
                  translations: {
                    en: { type: cards[0].headerType, url: cards[0].headerMediaFile }
                  }
                },
                // TITLE
                {
                  ...(isUpdate && standaloneIds.titleComponentId && { contentId: standaloneIds.titleComponentId }),
                  componentKey: 'rcs_card_title',
                  componentCategory: 'BODY',
                  dataType: 'TEXT',
                  translations: { en: cards[0].titleText }
                },
                // DESCRIPTION
                {
                  ...(isUpdate && standaloneIds.descComponentId && { contentId: standaloneIds.descComponentId }),
                  componentKey: 'rcs_card_description',
                  componentCategory: 'BODY',
                  dataType: 'TEXT',
                  translations: { en: cards[0].bodyText }
                },

                ...cards[0].actionButtons.map(btn => {
                  const isExistingButton = !!btn.id && !btn.isNew // Boolean flag
                  const buttonId = btn.id // Actual ID value

                  if (btn.type === 'quick_reply') {
                    return {
                      ...(isUpdate && isExistingButton && { contentId: buttonId }),
                      componentKey: 'rcs_action_button',
                      componentCategory: 'FOOTER',
                      dataType: 'JSON',
                      translations: {
                        en: {
                          type: 'quick_reply',
                          title: btn.text || 'Reply',
                          payload: btn.quickReplies?.map(q => q.text) || []
                        }
                      }
                    }
                  }

                  return {
                    ...(isUpdate && isExistingButton && { contentId: buttonId }),
                    componentKey: 'rcs_action_button',
                    componentCategory: 'FOOTER',
                    dataType: 'JSON',
                    translations: {
                      en:
                        btn.type === 'quick_reply'
                          ? {
                              type: 'quick_reply',
                              title: 'reply',
                              payload: btn.quickReplies?.map(q => q.text)
                            }
                          : btn.type === 'coupon_code'
                            ? {
                                type: btn.type,
                                title: 'coupon',
                                payload: btn.value
                              }
                            : {
                                type: btn.type,
                                title: btn.text,
                                payload: btn.value
                              }
                    }
                    // translations: {
                    //   en: {
                    //     type: btn.type,
                    //     title: btn.text,
                    //     payload: btn.value
                    //   }
                    // }
                  }
                })
              ]
            }
          ]
        },
        // Include fallback ONLY if present
        smsFallbackTextforRCS?.trim()
          ? {
              ...(standaloneIds.fallback?.groupId && { groupId: standaloneIds.fallback.groupId }),
              layoutType: 'BLOCK',
              configuration: {},
              contentUnits: [
                {
                  ...(standaloneIds.fallback?.unitId && { unitId: standaloneIds.fallback.unitId }),
                  unitName: 'Fallback',
                  components: [
                    {
                      ...(standaloneIds.fallback?.componentId && { contentId: standaloneIds.fallback.componentId }),
                      componentKey: 'rcs_fallback_sms_message',
                      componentCategory: 'BODY',
                      dataType: 'TEXT',
                      translations: { en: smsFallbackTextforRCS }
                    }
                  ]
                }
              ]
            }
          : null
      ].filter(Boolean)
    }
  }

  const getRcsCarouselPayload = () => {
    const carouselIds = apiId?.rcs?.carousel || {}
    const isUpdate = !!carouselIds.groupId
    const hasFallback = !!smsFallbackTextforRCS?.trim()

    return {
      configuration: {
        template_type: 'rich_card_carousel',
        ...(rcsSelectedVendor && { selected_vendor: rcsSelectedVendor }),
        template_source: 'cxp'
      },
      layoutGroups: [
        // ================================
        // CAROUSEL BLOCK
        // ================================
        {
          ...(isUpdate && { groupId: carouselIds.groupId }),
          layoutType: 'BLOCK',
          configuration: {
            card_orientation: cards[0]?.cardOrientation || 'vertical',
            media_height: cards[0]?.mediaHeight || 'medium'
          },
          contentUnits: cards.map((card, index) => {
            const isCardUpdate = isUpdate && !card.isNew

            return {
              ...(isCardUpdate && { unitId: card.id }),
              unitName: card.unitName || `Card ${index + 1}`,
              configuration: {},
              components: [
                // MEDIA
                card.headerMediaFile && {
                  ...(isCardUpdate &&
                    card.ids?.mediaId && {
                      contentId: card.ids.mediaId
                    }),
                  componentKey: 'rcs_media',
                  componentCategory: 'BODY',
                  dataType: 'JSON',
                  translations: {
                    en: {
                      type: card.headerType || 'image',
                      url: card.headerMediaFile
                    }
                  }
                },

                // TITLE
                card.titleText && {
                  ...(isCardUpdate &&
                    card.ids?.titleId && {
                      contentId: card.ids.titleId
                    }),
                  componentKey: 'rcs_card_title',
                  componentCategory: 'HEADER',
                  dataType: 'TEXT',
                  translations: { en: card.titleText }
                },

                // DESCRIPTION
                card.bodyText && {
                  ...(isCardUpdate &&
                    card.ids?.descId && {
                      contentId: card.ids.descId
                    }),
                  componentKey: 'rcs_card_description',
                  componentCategory: 'BODY',
                  dataType: 'TEXT',
                  translations: { en: card.bodyText }
                },

                // ACTION BUTTONS
                ...(card.actionButtons || []).map(btn => {
                  const isButtonUpdate = isUpdate && !btn.isNew

                  return {
                    ...(isButtonUpdate && btn.id && { contentId: btn.id }),
                    componentKey: 'rcs_action_button',
                    componentCategory: 'FOOTER',
                    dataType: 'JSON',
                    translations: {
                      en:
                        btn.type === 'quick_reply'
                          ? {
                              type: 'quick_reply',
                              title: 'reply',
                              payload: btn.quickReplies?.map(q => q.text)
                            }
                          : btn.type === 'coupon_code'
                            ? {
                                type: btn.type,
                                title: 'coupon',
                                payload: btn.value
                              }
                            : {
                                type: btn.type,
                                title: btn.text,
                                payload: btn.value
                              }
                    }
                    // translations: {
                    //   en: {
                    //     type: btn.type || 'visit_website',
                    //     title: btn.text,
                    //     payload: btn.value
                    //   }
                    // }
                  }
                })
              ].filter(Boolean)
            }
          })
        },

        // ================================
        // FALLBACK BLOCK
        // ================================
        hasFallback && {
          ...(isUpdate &&
            carouselIds?.fallback?.groupId && {
              groupId: carouselIds.fallback.groupId
            }),
          layoutType: 'BLOCK',
          configuration: {},
          contentUnits: [
            {
              ...(isUpdate &&
                carouselIds?.fallback?.unitId && {
                  unitId: carouselIds.fallback.unitId
                }),
              unitName: 'Fallback',
              components: [
                {
                  ...(isUpdate &&
                    carouselIds?.fallback?.componentId && {
                      contentId: carouselIds.fallback.componentId
                    }),
                  componentKey: 'rcs_fallback_sms_message',
                  componentCategory: 'BODY',
                  dataType: 'TEXT',
                  translations: { en: smsFallbackTextforRCS }
                }
              ]
            }
          ]
        }
      ].filter(Boolean)
    }
  }

  const getRCSPayload = rcsTemplateTypeParam => {
    if (rcsTemplateTypeParam === 'text') {
      return getRcsTextPayload()
    } else if (rcsTemplateTypeParam === 'rich') {
      return getRcsStandalonePayload()
    } else if (rcsTemplateTypeParam === 'rich_carousel') {
      return getRcsCarouselPayload()
    }
  }

  const getEmailPayload = (
    subjectLineParam = '',
    preheaderTextParam = '',
    emailValueParam = '',
    beefreeJSONParam = null
  ) => {
    const isUpdate =
      apiId.email.subject?.groupId &&
      apiId.email.preheader?.groupId &&
      apiId.email.customheader?.groupId &&
      apiId.email.body?.groupId

    const renderEngine = editorID === 2 ? 'BeeFree' : 'HTML'

    return {
      configuration: {
        renderEngine,
        editorId: editorID
      },

      layoutGroups: [
        // SUBJECT
        {
          layoutType: 'HEADER',
          ...(isUpdate && { groupId: apiId.email.subject.groupId }),
          contentUnits: [
            {
              ...(isUpdate && { unitId: apiId.email.subject.unitId }),
              unitName: 'Subject Line',
              components: [
                {
                  ...(isUpdate && { contentId: apiId.email.subject.componentId }),
                  componentKey: 'subject',
                  componentCategory: 'HEADER',
                  dataType: 'TEXT',
                  translations: { en: subjectLineParam }
                }
              ]
            }
          ]
        },

        // PREHEADER
        ...(preheaderTextParam?.trim()
          ? [
              {
                layoutType: 'HEADER',
                ...(isUpdate && { groupId: apiId.email.preheader.groupId }),
                contentUnits: [
                  {
                    ...(isUpdate && { unitId: apiId.email.preheader.unitId }),
                    unitName: 'Preheader_Text',
                    components: [
                      {
                        ...(isUpdate && {
                          contentId: apiId.email.preheader.componentId
                        }),
                        componentKey: 'preheader_text',
                        componentCategory: 'BODY',
                        dataType: 'TEXT',
                        translations: { en: preheaderTextParam }
                      }
                    ]
                  }
                ]
              }
            ]
          : []),

        {
          layoutType: 'HEADER',
          ...(isUpdate && { groupId: apiId.email.customheader.groupId }),
          contentUnits: [
            {
              ...(isUpdate && { unitId: apiId.email.customheader.unitId }),
              unitName: 'Email Custom Header',
              components: (customKeyValuePairs || []).map((pair, index) => ({
                ...(isUpdate && { contentId: apiId.email.customheader.componentIds?.[index] }),
                // componentLabel: "",
                componentKey: 'email_custom_header',
                componentCategory: 'HEADER',
                dataType: 'JSON',
                translations: { en: { key: pair.key, value: pair.value } }
                // configuration: {}
              }))
            }
          ]
        },

        // ATTACHMENTS — only send this section when there are attachments to save,
        // or when an existing attachments group needs to be updated (e.g. cleared out).
        ...(attachments?.length > 0 || apiId.email.attachments?.groupId
          ? [
              {
                layoutType: 'SECTION',
                ...(apiId.email.attachments?.groupId && { groupId: apiId.email.attachments.groupId }),
                contentUnits: [
                  {
                    ...(apiId.email.attachments?.unitId && { unitId: apiId.email.attachments.unitId }),
                    unitName: 'Email Attachments',
                    // No component object when empty — matches email_custom_header's
                    // convention below, and keeps the backend's mandatory-content
                    // validation from flagging an optional, empty attachment.
                    components:
                      attachments?.length > 0
                        ? [
                            {
                              ...(apiId.email.attachments?.componentId && {
                                contentId: apiId.email.attachments.componentId
                              }),
                              componentKey: 'email_attachment',
                              componentCategory: 'MEDIA',
                              dataType: 'JSON',
                              componentLabel: 'Email Attachment',
                              translations: {
                                en: attachments.map(attachment => ({
                                  url: attachment.url,
                                  name: attachment.name,
                                  mediaType: attachment.mediaType,
                                  mimeType: attachment.mimeType,
                                  size: attachment.size,
                                  ...(attachment.sizeBytes > 0 && { sizeBytes: attachment.sizeBytes })
                                }))
                              }
                            }
                          ]
                        : []
                  }
                ]
              }
            ]
          : []),

        {
          layoutType: 'BLOCK',
          ...(isUpdate && { groupId: apiId.email.body.groupId }),
          contentUnits: [
            {
              ...(isUpdate && { unitId: apiId.email.body.unitId }),
              unitName: 'Body Content',
              components: [
                {
                  ...(isUpdate && { contentId: apiId.email.body.componentId }),
                  componentKey: 'body_html',
                  componentCategory: 'BODY',
                  dataType: 'HTML',
                  translations: { en: emailValueParam }
                },
                // GrapesJS project data — stored so editor can reload exact state on edit
                ...(beefreeJSONParam
                  ? [
                      {
                        componentKey: 'beefree_json',
                        componentCategory: 'BODY',
                        dataType: 'JSON',
                        translations: { en: beefreeJSONParam }
                      }
                    ]
                  : [])
              ]
            }
          ]
        }
      ]
    }
  }

  const getSmsPayload = () => {
    const isUpdate = apiId.sms.groupId && apiId.sms.unitId && apiId.sms.componentId

    return {
      layoutGroups: [
        {
          // include groupId ONLY if update
          ...(isUpdate && { groupId: apiId.sms.groupId }),

          layoutType: 'SECTION',
          configuration: {},

          contentUnits: [
            {
              // include unitId ONLY if update
              ...(isUpdate && { unitId: apiId.sms.unitId }),

              unitName: 'Message Content',
              components: [
                {
                  // include contentId ONLY if update
                  ...(isUpdate && { contentId: apiId.sms.componentId }),

                  componentKey: 'message',
                  componentCategory: 'BODY',
                  dataType: 'TEXT',
                  translations: {
                    en: smsValue
                  }
                }
              ]
            }
          ]
        }
      ]
    }
  }
  const getWhatsappStandardPayload = () => {
    return {
      configuration: {
        // 'standard' is only the internal cardType value (vs. 'carousel') - the
        // WhatsApp API's own template_type vocabulary calls this shape 'custom'.
        template_type: 'custom',
        ...(whatsappSelectedVendor && { selected_vendor: whatsappSelectedVendor }),
        template_source: 'cxp',
        template_category: templateCategory
      },
      layoutGroups: [
        // HEADER
        ...(whatsappHeaderType && whatsappHeaderType !== 'none'
          ? [
              {
                groupId: apiId.whatsapp.standard.headerGroupId || undefined,
                layoutType: 'HEADER',
                configuration: {},
                contentUnits: [
                  {
                    unitId: apiId.whatsapp.standard.headerUnitId || undefined,
                    unitName: 'Header Title',
                    components: [
                      {
                        contentId: apiId.whatsapp.standard.headerId || undefined,
                        componentKey: 'whatsapp_header_title',
                        componentCategory: 'HEADER',
                        dataType: 'JSON',
                        translations: {
                          en: {
                            type: whatsappHeaderType,
                            value:
                              whatsappHeaderType === 'text'
                                ? whatsappHeaderText
                                : whatsappHeaderLink || whatsappHeaderFile
                          }
                        }
                      }
                    ]
                  }
                ]
              }
            ]
          : []),

        // BODY
        {
          groupId: apiId.whatsapp.standard.bodyGroupId || undefined,
          layoutType: 'BLOCK',
          configuration: {},
          contentUnits: [
            {
              unitId: apiId.whatsapp.standard.bodyUnitId || undefined,
              unitName: 'Body Content',
              components: [
                {
                  contentId: apiId.whatsapp.standard.bodyId || undefined,
                  componentKey: 'whatsapp_body',
                  componentCategory: 'BODY',
                  dataType: 'TEXT',
                  translations: { en: whatsappValue }
                }
              ]
            }
          ]
        },

        // FOOTER TEXT
        ...((whatsappFooterText || '').trim() && [
          {
            groupId: apiId.whatsapp.standard.footerGroupId || undefined,
            layoutType: 'FOOTER',
            configuration: {},
            contentUnits: [
              {
                unitId: apiId.whatsapp.standard.footerUnitId || undefined,
                unitName: 'Footer',
                components: [
                  {
                    contentId: apiId.whatsapp.standard.footerId || undefined,
                    componentKey: 'whatsapp_footer',
                    componentCategory: 'FOOTER',
                    dataType: 'TEXT',
                    translations: { en: whatsappFooterText }
                  }
                ]
              }
            ]
          }
        ]),

        // ✅ ACTION BUTTON GROUP (FIXED)
        {
          groupId: apiId.whatsapp.standard.actionGroupId || undefined,
          layoutType: 'FOOTER',
          configuration: {},
          contentUnits: [
            {
              unitId: apiId.whatsapp.standard.actionUnitId || undefined,
              unitName: 'Action',
              components: whatsappActionButtons.map((btn, index) => ({
                contentId: apiId.whatsapp.standard.actionButtonIds[index] || undefined,
                componentKey: 'whatsapp_action_button',
                componentCategory: 'FOOTER',
                dataType: 'JSON',
                translations: {
                  en:
                    btn.type === 'quick_reply'
                      ? {
                          type: 'quick_reply',
                          title: 'reply',
                          payload: btn.quickReplies?.map(q => q.text)
                        }
                      : btn.type === 'coupon_code'
                        ? {
                            type: btn.type,
                            title: 'coupon',
                            payload: btn.value
                          }
                        : {
                            type: btn.type,
                            title: btn.text,
                            payload: btn.value
                          }
                }
              }))
            }
          ]
        }
      ]
    }
  }

  const getWhatsappCarouselPayload = (isUpdate = false) => {
    return {
      configuration: {
        template_type: 'carousel',
        ...(whatsappSelectedVendor && { selected_vendor: whatsappSelectedVendor }),
        template_source: 'cxp',
        template_category: templateCategory
      },

      layoutGroups: [
        // ==========================
        // 1️⃣ BODY
        // ==========================
        {
          layoutGroupId: isUpdate ? apiId.whatsapp.carousel.bodyGroupId : undefined,
          layoutType: 'BLOCK',
          configuration: {},
          contentUnits: [
            {
              unitId: isUpdate ? apiId.whatsapp.carousel.bodyUnitId : undefined,
              unitName: 'Body Content',
              components: [
                {
                  contentId: isUpdate ? apiId.whatsapp.carousel.bodyComponentId : undefined,
                  componentKey: 'whatsapp_body',
                  componentCategory: 'BODY',
                  dataType: 'TEXT',
                  translations: {
                    en: whatsappValue
                  }
                }
              ]
            }
          ]
        },

        // ==========================
        // 2️⃣ CARDS
        // ==========================
        {
          layoutGroupId: isUpdate ? apiId.whatsapp.carousel.cardsGroupId : undefined,
          layoutType: 'BLOCK',
          configuration: {},
          contentUnits: whatsappCards.map((card, index) => {
            const cardApi = apiId.whatsapp.carousel.cards[index] || {}

            return {
              unitId: isUpdate ? cardApi.unitId : undefined,
              unitName: `Card ${index + 1}`,
              components: [
                // HEADER
                {
                  contentId: isUpdate ? cardApi.headerId : undefined,
                  componentKey: 'whatsapp_header_title',
                  componentCategory: 'HEADER',
                  dataType: 'JSON',
                  translations: {
                    en: {
                      type: card.headerType,
                      value: card.headerContent || card.headerMediaFile || ''
                    }
                  }
                },

                // BODY
                {
                  contentId: isUpdate ? cardApi.bodyId : undefined,
                  componentKey: 'whatsapp_content',
                  componentCategory: 'BODY',
                  dataType: 'TEXT',
                  translations: {
                    en: card.bodyText
                  }
                },

                // FOOTER ACTION BUTTONS
                ...(card.actionButtons || []).map((btn, btnIndex) => ({
                  contentId: isUpdate ? cardApi.actionIds?.[btnIndex] : undefined,
                  componentKey: 'whatsapp_action_button',
                  componentCategory: 'FOOTER',
                  dataType: 'JSON',
                  translations: {
                    en:
                      btn.type === 'quick_reply'
                        ? {
                            type: 'quick_reply',
                            title: 'reply',
                            payload: btn.quickReplies?.map(q => q.text)
                          }
                        : btn.type === 'coupon_code'
                          ? {
                              type: btn.type,
                              title: 'coupon',
                              payload: btn.value
                            }
                          : {
                              type: btn.type,
                              title: btn.text,
                              payload: btn.value
                            }
                  }
                  // translations: {
                  //   en:
                  //     btn.type === "quick_reply"
                  //       ? {
                  //         type: "quick_reply",
                  //         title: btn.text,
                  //         payload: btn.quickReplies?.map(q => q.text)
                  //       }
                  //       : {
                  //         type: btn.type,
                  //         title: btn.text,
                  //         payload: btn.value
                  //       }
                  // }
                }))
              ]
            }
          })
        }
      ]
    }
  }

  const getWhatsappPayload = () => {
    if (cardType === 'standard') {
      return getWhatsappStandardPayload()
    } else if (cardType === 'carousel') {
      return getWhatsappCarouselPayload()
    }
  }
  const getTemplateList = async payload => {
    try {
      let url = `${templateUrl}/search`
      const response = await api.post(url, payload)

      setTemplateListData(response?.data?.data?.templates ?? [])
      setTotalTemplates(response?.data?.data?.total ?? 0)
      // getTemplateFilterList()
    } catch {
      // errors are already shown by the api client's response interceptor
    }
  }

  /**
   * Fetch Published Template List
   * @param {Object} param0: {searchText, status, channel, tags, sortBy, sortOrder, page, pageSize}: Filter and Pagination options
   * @returns Published Template List
   */
  const getPublishedTemplateList = async ({
    searchText = '',
    status = ['Published'],
    channel = [],
    tags: tagsFilter = [],
    sortBy = 'created_at',
    sortOrder = 'asc',
    page = 1,
    pageSize = 10
  }) => {
    try {
      const body = {
        pagination: {
          page,
          pageSize
        },
        sorting: {
          field: sortBy,
          order: sortOrder
        },
        filter: {
          searchKeyword: searchText,
          status: status,
          channels: channel,
          tags: tagsFilter
        }
      }

      // const response = await api.post(templateUrl, inputData)

      const response = await api.post(`${templateUrl}/search`, body)
      setPublishedTemplateList(response?.data?.data?.templates ?? [])
      return response?.data?.data?.templates
    } catch {
      // errors are already shown by the api client's response interceptor
    }
  }

  const getTemplateWithCampaigns = async id => {
    try {
      const response = await api.get(`${templateUrl}/${id}`, { params: { includeCampaigns: true } })
      return response?.data?.data || null
    } catch {
      return null
    }
  }

  const getTemplate = async id => {
    try {
      const response = await api.get(`${templateUrl}/${id}`)

      const template = response?.data?.data
      setSelectedTemplate(template)
      setSelectedTemplateId(template?.id)
      setTemplateName(template?.templateName)
      setTemplateDescription(template?.description)
      setTemplateLanguage(template?.language || 'en')
      setTags(template?.tags)
      setSelectedChannels(template?.channels || [])
      setPreviousUserChannels(template?.channels || [])
      updateChannelStates(template?.channels || [])
      return template
    } catch {
      // errors are already shown by the api client's response interceptor
    }
  }

  const getTemplateFilterList = async () => {
    try {
      const response = await api.get(`${getTemplatesFilter}`)

      const filtersList = response?.data?.data?.filters || []

      // helper function to extract labels for a given key
      const getLabels = (list, key) => {
        const item = list.find(f => f.key === key)
        return item ? item.options.map(o => o.label) : []
      }

      const tagListFilter = getLabels(filtersList, 'tags')

      setTemplatesTagList(tagListFilter)
      const filters = response?.data?.data?.filters || []
      const otherFilters = response?.data?.data?.otherFilters || []

      const tagsFilter = filters.find(f => f.key === 'tags')
      setHasTagFilter(!!tagsFilter)
      setTemplateFilterList(tagsFilter ? tagsFilter.options.map(o => o.value) : [])

      const withVendorStatuses = otherFilters.map(filter => {
        if (filter.key !== 'status' || !Array.isArray(filter.options)) {
          return filter
        }

        const isCapitalized = /^[A-Z]/.test(filter.options[0]?.value || '')
        const existing = filter.options.map(option => option.value?.toLowerCase())

        const missing = ['pending', 'rejected']
          .filter(status => !existing.includes(status))
          .map(status => {
            const value = isCapitalized ? status.charAt(0).toUpperCase() + status.slice(1) : status

            return { label: value, value }
          })

        const options = [...filter.options, ...missing]
        const isArchived = option => option.value?.toLowerCase() === 'archived'

        return { ...filter, options: [...options.filter(option => !isArchived(option)), ...options.filter(isArchived)] }
      })

      setTemplateOtherFilterList(withVendorStatuses)

      const initialSelectedFilters = {}
      otherFilters.forEach(f => {
        initialSelectedFilters[f.key] = []
      })

      return initialSelectedFilters
    } catch {
      setTemplateFilterList([])
      setTemplateOtherFilterList([])
      setHasTagFilter(false)
      return {}
    }
  }

  const validateTemplate = async templateID => {
    try {
      // Validate step renders the checklist inline — no success/failure toast needed here.
      const response = await api.get(`${templateUrl}/validate/${templateID}`, { skipGlobalToast: true })

      const templateValidationSummary = response?.data?.data || []
      setTemplateValidationCheckList(templateValidationSummary)

      setIsTemplateValid(
        templateValidationSummary?.validations?.every(channel =>
          channel?.validation_rules?.every(rule => rule?.result)
        ) ?? false
      )
      return true
    } catch {
      // errors are already shown by the api client's response interceptor
    }
  }

  const updateIgnoredValidations = async (templateId, channelId, { add = [], remove = [] } = {}) => {
    try {
      const response = await api.patch(
        templateChannelIgnoredValidationsUrl(templateId, channelId),
        { add, remove },
        { skipGlobalToast: true }
      )
      const ignoredValidations = response?.data?.data?.ignoredValidations ?? response?.data?.ignoredValidations ?? []
      return { ok: true, ignoredValidations }
    } catch (error) {
      const message = error?.response?.data?.message || error?.response?.data?.error || 'Failed to save ignore settings'
      return { ok: false, message }
    }
  }

  const deleteTemplate = async (id, templateStatus) => {
    try {
      const queryParams = {
        status: templateStatus
      }
      await api.delete(`${templateUrl}/${id}`, {
        params: queryParams
      })
    } catch {
      // errors are already shown by the api client's response interceptor
    }
  }

  const createTemplate = async (validationStatus, inputData) => {
    try {
      const response = await api.post(templateUrl, inputData, {
        params: {
          validation: validationStatus
        },
        skipGlobalToast: true
      })
      if (response?.status === 200 || response?.status === 201) {
        const template = response?.data?.data
        setIsTemplateSetupModified(false)

        setSelectedTemplate(template)
        setTemplateName(template?.templateName)
        setTemplateDescription(template?.description)
        setTemplateLanguage(template?.language || 'en')
        setTags(template?.tags)
        setSelectedChannels(template?.channels || [])
        setPreviousUserChannels(template?.channels || [])
        updateChannelStates(template?.channels || [])
        return true
      }
    } catch (error) {
      if (error) {
        setIsTemplateSetupModified(true)
        setTemplateSaveStatus({
          type: 'error',
          message: error?.response?.data?.message || error?.response?.data?.error || 'Failed to save template'
        })
      }
    }
  }
  const getCheckUsageTemplates = async idRow => {
    try {
      const inputData = { templateIds: idRow }
      const response = await api.post(`${templateUrl}/check/usage`, inputData)
      if (response?.status === 200 || response?.status === 201) {
        return response?.data?.data
      }
    } catch (error) {
      if (error) {
        setIsTemplateSetupModified(true)
      }
    }
  }

  const validateTemplatePayload = async (type, inputPayload) => {
    try {
      const inputData = {
        action: type,
        data: inputPayload
      }

      const response = await api.post(`${templateUrl}/validate-payload`, inputData)
      if (response?.status === 200) {
        return true
      }
      return false
    } catch {
      // errors are already shown by the api client's response interceptor
    }
  }

  const cloneTemplate = async (templateId, updatedTemplateName) => {
    try {
      const inputData = {
        templateName: updatedTemplateName
      }

      const response = await api.post(`${templateUrl}/${templateId}/clone`, inputData)

      if (response?.status === 200 || response?.status === 201) {
        showSuccess('Template cloned successfully')
        getTemplateList({})
      } else {
        showError(`Failed to clone template: ${response?.message || 'Unknown error'}`)
      }
    } catch {
      // errors are already shown by the api client's response interceptor
    }
  }

  const updateTemplate = async (templateId, validationStatus, inputData) => {
    if (isTemplateChannelsModified) {
      // Await both calls so the main PUT sees the updated channel state
      if (updatedDisabledChannels.length > 0) {
        await disableTemplateChannels(templateId, updatedDisabledChannels)
      }

      if (updatedEnabledChannels.length > 0) {
        await enableTemplateChannels(templateId, updatedEnabledChannels)
      }
    }

    try {
      const response = await api.put(`${templateUrl}/${templateId}`, inputData, {
        params: {
          validation: validationStatus
        },
        skipGlobalToast: true
      })
      if (response?.status === 200 || response?.status === 201) {
        const template = response?.data?.data
        setIsTemplateSetupModified(false)
        setIsTemplateChannelsModified(false)
        setUpdatedEnabledChannels([])
        setUpdatedDisabledChannels([])
        setSelectedTemplate(template)
        setSelectedTemplateId(template?.id)
        setTemplateName(template?.templateName)
        setTemplateDescription(template?.description)
        setTemplateLanguage(template?.language || 'en')
        setTags(template?.tags)
        setSelectedChannels(template?.channels || [])
        setPreviousUserChannels(template?.channels || [])
        updateChannelStates(template?.channels || [])
        return true
      }
    } catch (error) {
      if (error) {
        setIsTemplateSetupModified(true)
        setTemplateSaveStatus({
          type: 'error',
          message: error?.response?.data?.message || error?.response?.data?.error || 'Failed to update template'
        })
      }
    }
  }

  const templateBulkAction = async (selectedIDList, bulkAction) => {
    try {
      const inputData = {
        templates: selectedIDList,
        action: bulkAction
      }
      const response = await api.put(`${templateUrl}/status`, inputData)
      if (response?.status === 200 || response?.status === 204) {
        getTemplateList({})
      }
    } catch {
      // errors are already shown by the api client's response interceptor
    }
  }
  const enableTemplateChannels = async (templateId, channelIds) => {
    try {
      const queryParams = channelIds.map(id => `channelId=${id}`).join('&')

      const response = await api.put(`${templateUrl}/${templateId}/templateChannels?${queryParams}`, {})
      if (response?.status === 200 || response?.status === 204) {
        // nothing to do on success
      } else {
        showError('Failed to enabled channels')
      }
    } catch {
      // errors are already shown by the api client's response interceptor
    }
  }

  const disableTemplateChannels = async (templateId, templateChannelIds) => {
    try {
      const queryParams = templateChannelIds.map(id => `templateChannelId=${id}`).join('&')

      const response = await api.delete(`${templateUrl}/${templateId}/templateChannels?${queryParams}`)

      if (response?.status === 200 || response?.status === 204) {
        // nothing to do on success
      } else {
        showError('Failed to disable channels')
      }
    } catch {
      // errors are already shown by the api client's response interceptor
    }
  }

  const GetTemplateChannelTranslation = async channelId => {
    try {
      const response = await api.get(`${templateUrl}/${selectedTemplateId}/channeldata/${channelId}`)

      const channelMessage = response?.data?.data
      return channelMessage
    } catch {
      // errors are already shown by the api client's response interceptor
    }
  }

  const UpsertEmailChannelTranslation = async (validationStatus, editorIdParam, emailPayload) => {
    try {
      setTemplateSaveStatus(null)

      const response = await api.put(
        `${templateUrl}/${selectedTemplate?.id}/channeldata/${emailChannelId}`,
        emailPayload,
        {
          // params: { validation: validationStatus }
          params: { validation: true },
          skipGlobalToast: true
        }
      )

      if (response?.status === 200) {
        setIsEmailContentModified(false)
        setTemplateSaveStatus({ type: 'success', message: 'Email content saved successfully' })

        fetchEmailTranslation(emailChannelId)
        return true
      }
      return false
    } catch (error) {
      if (error) {
        setIsEmailContentModified(true)
        setTemplateSaveStatus({
          type: 'error',
          message: error?.response?.data?.message || error?.response?.data?.error || 'Failed to save email content'
        })
      }
    }
  }
  const fetchEmailTranslation = async emailChannelIdParam => {
    if (selectedTemplateId && emailTemplateChannelId && emailChannelIdParam) {
      const translation = await GetTemplateChannelTranslation(emailChannelIdParam)
      const extractEmailIds = translationData => {
        let subject = {}
        let preheader = {}
        let body = {}
        let customheader = { groupId: '', unitId: '', componentIds: [] }
        let attachmentIds = { groupId: '', unitId: '', componentId: '' }

        translationData?.layoutGroups?.forEach(group => {
          group.contentUnits.forEach(unit => {
            unit.components.forEach(comp => {
              if (comp.componentKey === 'subject') {
                subject = {
                  groupId: group.groupId,
                  unitId: unit.unitId,
                  componentId: comp.contentId
                }
              }

              if (comp.componentKey === 'preheader_text') {
                preheader = {
                  groupId: group.groupId,
                  unitId: unit.unitId,
                  componentId: comp.contentId
                }
              }

              if (comp.componentKey === 'email_custom_header') {
                customheader.groupId = group.groupId
                customheader.unitId = unit.unitId
                customheader.componentIds.push(comp.contentId)
              }
              if (comp.componentKey === 'email_attachment') {
                attachmentIds.groupId = group.groupId
                attachmentIds.unitId = unit.unitId
                attachmentIds.componentId = comp.contentId
              }
              if (comp.componentKey === 'body_html') {
                body = {
                  groupId: group.groupId,
                  unitId: unit.unitId,
                  componentId: comp.contentId
                }
              }
            })
          })
        })

        return { subject, preheader, body, customheader, attachments: attachmentIds }
      }
      const emailIds = extractEmailIds(translation)

      setApiId(prev => ({
        ...prev,
        email: {
          subject: emailIds.subject,
          preheader: emailIds.preheader,
          body: emailIds.body,
          customheader: emailIds.customheader,
          attachments: emailIds.attachments
        }
      }))
      const extractEmailContentToUI = translationData => {
        let subject = ''
        let preheader = ''
        let body = ''
        let bodyJson = null // GrapesJS project data
        let customheader = []
        let attachmentList = []

        translationData?.layoutGroups?.forEach(group => {
          group.contentUnits.forEach(unit => {
            unit.components.forEach(comp => {
              const value = comp.translations?.en || ''

              if (comp.componentKey === 'subject') {
                subject = value
              }
              if (comp.componentKey === 'preheader_text') {
                preheader = value
              }
              if (comp.componentKey === 'body_html') {
                body = value
              }
              if (comp.componentKey === 'body_json' || comp.componentKey === 'beefree_json') {
                bodyJson = comp.translations?.en || null
              }
              if (comp.componentKey === 'email_custom_header' && value.key && value.value) {
                customheader.push({
                  key: value.key,
                  value: value.value
                })
              }
              // email_attachment stores its whole list under a single component
              // (translations.en is the array), unlike every other key here.
              if (comp.componentKey === 'email_attachment') {
                attachmentList = comp.translations?.en || []
              }
            })
          })
        })

        return { subject, preheader, body, bodyJson, customheader, attachments: attachmentList }
      }
      const emailUI = extractEmailContentToUI(translation)

      setSubjectLine(emailUI.subject)
      setPreheaderText(emailUI.preheader)
      setEmailValue(emailUI.body)
      setHtmlValue(emailUI.body)
      setCustomKeyValuePairs(emailUI.customheader)
      setAttachments(emailUI.attachments)
      sendTemplateMailToMailpit(emailUI.body)

      // Restore GrapesJS editor state from saved JSON (if available)
      if (emailUI.bodyJson) {
        setBeefreeJSON(emailUI.bodyJson)
      }

      // setBeefreeJSON(translation?.beefreeContentJson)
      setEditorID(Number(translation?.configuration?.editorId) || 2)
      setEmailTemplateContentId(translation?.templateChannelTranslationId)
    }
  }
  const UpsertWhatsappChannelTranslation = async (validationStatus, editorIdParam, whatsappPayload) => {
    try {
      setTemplateSaveStatus(null)

      const response = await api.put(
        `${templateUrl}/${selectedTemplate?.id}/channeldata/${whatsappChannelId}`,
        whatsappPayload,
        {
          params: { validation: true },
          // params: {
          //   validation: validationStatus
          // }
          skipGlobalToast: true
        }
      )

      if (response?.status === 200) {
        setTemplateSaveStatus({ type: 'success', message: 'Whatsapp content saved successfully' })
        setIsWhatsappContentModified(false)
        fetchWhatsappTranslation(whatsappChannelId)
        return true
      }
      return false
    } catch (error) {
      setIsWhatsappContentModified(true)
      setTemplateSaveStatus({
        type: 'error',
        message: error?.response?.data?.message || error?.response?.data?.error || 'Failed to save whatsapp content'
      })
    }
  }
  const fetchWhatsappTranslation = async whatsappChannelIdParam => {
    if (selectedTemplateId && whatsappTemplateChannelId && whatsappChannelIdParam) {
      let translation = await GetTemplateChannelTranslation(whatsappChannelIdParam)

      setTemplateCategory(translation?.configuration?.template_category || 'marketing')
      setWhatsappSelectedVendor(translation?.configuration?.selected_vendor || null)

      //  setCardType(translation?.configuration?.template_type)

      if (translation?.configuration?.template_type === 'custom') {
        // API calls this shape 'custom'; internally it's still the 'standard' cardType.
        setCardType('standard')

        const extractWhatsappStandard = response => {
          const layoutGroups = response?.layoutGroups || []

          const getGroups = layoutType => layoutGroups.filter(g => g.layoutType === layoutType)

          const headerGroup = getGroups('HEADER')[0] || null
          const bodyGroup = getGroups('BLOCK')[0] || null
          const footerGroups = getGroups('FOOTER')

          const footerTextGroup = footerGroups.find(g => g.contentUnits?.[0]?.unitName === 'Footer') || null

          const actionButtonGroup = footerGroups.find(g => g.contentUnits?.[0]?.unitName === 'Action') || null

          const headerUnit = headerGroup?.contentUnits?.[0]
          const bodyUnit = bodyGroup?.contentUnits?.[0]
          const footerTextUnit = footerTextGroup?.contentUnits?.[0]
          const actionUnit = actionButtonGroup?.contentUnits?.[0]

          const headerComp = headerUnit?.components?.find(c => c.componentKey === 'whatsapp_header_title')

          const bodyComp = bodyUnit?.components?.find(c => c.componentKey === 'whatsapp_body')

          const footerComp = footerTextUnit?.components?.find(c => c.componentKey === 'whatsapp_footer')

          const actionButtons = actionUnit?.components || []

          return {
            headerType: headerComp?.translations?.en?.type || '',
            headerValue: headerComp?.translations?.en?.value || '',
            bodyText: bodyComp?.translations?.en || '',
            footerText: footerComp?.translations?.en || '',
            buttons: actionButtons.map(btn => {
              const en = btn.translations?.en || {}

              // ✅ HANDLE BOTH ARRAY AND STRING PAYLOAD
              let payloadValue = ''
              let quickReplyValues = []

              if (en.payload !== undefined && en.payload !== null) {
                if (Array.isArray(en.payload)) {
                  // Array: first item = value, full array = quickReplies
                  payloadValue = en.payload[0] || ''
                  quickReplyValues = en.payload.filter(item => item) // Remove empty strings
                } else {
                  // String: use as both value and single-item quickReply
                  payloadValue = en.payload
                  quickReplyValues = [en.payload].filter(item => item) // Remove empty strings
                }
              }

              return {
                id: btn.contentId,
                type: en.type || '',
                text: en.title || '',
                value: payloadValue, // ALWAYS STRING
                quickReplies: quickReplyValues.map((text, qIdx) => ({
                  id: `${btn.contentId}_qr_${qIdx}`,
                  text
                })) // ALWAYS ARRAY of {id, text} objects (empty if no payload)
              }
            })
          }
        }

        const result = extractWhatsappStandard(translation)

        // ---- SET STATES ----
        setWhatsappHeaderType(result?.headerType)
        // setHeaderType(result?.headerType);
        setWhatsappHeaderText(result?.headerValue)
        setWhatsappHeaderLink(result?.headerValue)
        setWhatsappValue(result?.bodyText)
        setWhatsappFooterText(result?.footerText)

        // 🔥 SET ACTION BUTTONS FROM API
        setWhatsappActionButtons(result?.buttons)
      } else if (translation?.configuration?.template_type === 'carousel') {
        setCardType('carousel')
        const extractWhatsappButtons = (components = []) => {
          const buttons = []
          const actionIds = []

          components.forEach(component => {
            if (component.componentKey !== 'whatsapp_action_button') {
              return
            }

            const en = component.translations?.en
            if (!en) {
              return
            }

            const buttonId = component.contentId
            actionIds.push(buttonId)

            // QUICK REPLY BUTTON
            if (en.type === 'quick_reply') {
              buttons.push({
                id: buttonId,
                type: 'quick_reply',
                text: en.title || '',
                quickReplies: (en.payload || []).map((text, index) => ({
                  id: `${buttonId}_qr_${index}`, // stable UI id
                  text
                }))
              })
              return
            }

            // CTA BUTTONS (url / phone / copy_code)
            buttons.push({
              id: buttonId,
              type: en.type,
              text: en.title || '',
              value: en.payload || ''
            })
          })

          return {
            buttons,
            actionIds
          }
        }

        const extractWhatsappCarouselCards = (layoutGroups = []) => {
          const bodyGroup = layoutGroups.find(g => g.contentUnits?.[0]?.unitName === 'Body Content')

          const cardGroup = layoutGroups.find(g => g.contentUnits?.[0]?.unitName?.startsWith('Card'))

          if (!bodyGroup || !cardGroup) {
            return { bodyText: '', cards: [], apiIds: {} }
          }

          // BODY
          const bodyUnit = bodyGroup.contentUnits[0]
          const bodyComponent = bodyUnit.components.find(c => c.componentKey === 'whatsapp_body')

          const bodyText = bodyComponent?.translations?.en || ''

          const apiIds = {
            bodyGroupId: bodyGroup.groupId,
            bodyUnitId: bodyUnit.unitId,
            bodyComponentId: bodyComponent?.contentId,
            cardsGroupId: cardGroup.groupId,
            cards: []
          }

          const extractedCards = cardGroup.contentUnits.map(unit => {
            const card = {
              id: unit.unitId,
              headerType: '',
              headerContent: '',
              headerMediaFile: '',
              bodyText: '',
              actionButtons: [],
              ids: {
                headerId: null,
                bodyId: null,
                actionIds: []
              }
            }

            unit.components.forEach(component => {
              const en = component.translations?.en

              switch (component.componentKey) {
                case 'whatsapp_header_title':
                  card.headerType = en?.type || ''
                  if (en?.type === 'text') {
                    card.headerContent = en.value || ''
                  } else {
                    card.headerMediaFile = en.value || ''
                  }
                  card.ids.headerId = component.contentId
                  break

                case 'whatsapp_content':
                  card.bodyText = en || ''
                  card.ids.bodyId = component.contentId
                  break

                case 'whatsapp_action_button': {
                  const { buttons, actionIds } = extractWhatsappButtons([component])
                  card.actionButtons.push(...buttons)
                  card.ids.actionIds.push(...actionIds)
                  break
                }

                default:
                  break
              }
            })

            // Save API IDs
            apiIds?.cards?.push({
              unitId: unit.unitId,
              headerId: card.ids.headerId,
              bodyId: card.ids.bodyId,
              actionIds: card.ids.actionIds
            })

            return card
          })

          return {
            bodyText,
            cards: extractedCards,
            apiIds
          }
        }
        const {
          bodyText,
          cards: whatsappCarouselCards,
          apiIds
        } = extractWhatsappCarouselCards(translation?.layoutGroups)

        setWhatsappValue(bodyText)
        setWhatsappCards(whatsappCarouselCards)

        setApiId(prev => ({
          ...prev,
          whatsapp: {
            ...prev.whatsapp,
            carousel: apiIds
          }
        }))
        setCardType('carousel')
      }
    }
  }
  const UpsertSMSChannelTranslation = async (validationStatus, editorIdParam, smsPayload) => {
    try {
      setTemplateSaveStatus(null)

      const response = await api.put(`${templateUrl}/${selectedTemplate?.id}/channeldata/${smsChannelId}`, smsPayload, {
        params: { validation: true },
        // params: {
        //   validation: validationStatus

        // }
        skipGlobalToast: true
      })

      if (response?.status === 200) {
        setTemplateSaveStatus({ type: 'success', message: 'SMS content saved successfully' })
        setIsSmsContentModified(false)

        fetchSMSTranslation(smsChannelId)
        return true
      }
      return false
    } catch (error) {
      if (error) {
        setIsSmsContentModified(true)
        setTemplateSaveStatus({
          type: 'error',
          message: error?.response?.data?.message || error?.response?.data?.error || 'Failed to save SMS content'
        })
      }
    }
  }
  const fetchSMSTranslation = async smsChannelIdParam => {
    if (selectedTemplateId && smsTemplateChannelId && smsChannelIdParam) {
      const translation = await GetTemplateChannelTranslation(smsChannelIdParam)
      const groupId = translation?.layoutGroups?.[0]?.groupId || ''
      const unitId = translation?.layoutGroups?.[0]?.contentUnits?.[0]?.unitId || ''
      const componentId = translation?.layoutGroups?.[0]?.contentUnits?.[0]?.components?.[0]?.contentId || ''
      const translationalSmsValue = translation?.layoutGroups[0]?.contentUnits[0]?.components[0]?.translations?.en
      setApiId(prev => ({
        ...prev,
        sms: {
          groupId,
          unitId,
          componentId
        }
      }))
      setSmsValue(translationalSmsValue)
      // setCount(translationalSmsValue?.length)
      // setEditorID(translation?.editorId)
      // setSmsTemplateContentId(translation?.templateChannelTranslationId)
    }
  }
  const UpsertRCSChannelTranslation = async (validationStatus, editorIdParam, rcsPayload) => {
    try {
      setTemplateSaveStatus(null)

      const response = await api.put(`${templateUrl}/${selectedTemplate?.id}/channeldata/${rcsChannelId}`, rcsPayload, {
        params: { validation: true },
        skipGlobalToast: true
      })

      if (response?.status === 200) {
        setTemplateSaveStatus({ type: 'success', message: 'RCS content saved successfully' })
        setIsRCSContentModified(false)

        fetchRCSTranslation(rcsChannelId)
        return true
      }
      return false
    } catch (error) {
      if (error) {
        setIsRCSContentModified(true)
        setTemplateSaveStatus({
          type: 'error',
          message: error?.response?.data?.message || error?.response?.data?.error || 'Failed to save RCS content'
        })
      }
    }
  }
  const fetchRCSTranslation = async rcsChannelIdParam => {
    if (selectedTemplateId && rcsTemplateChannelId && rcsChannelIdParam) {
      let translation = await GetTemplateChannelTranslation(rcsChannelIdParam)
      setRcsSelectedVendor(translation?.configuration?.selected_vendor || null)

      if (translation?.configuration?.template_type === 'text_message') {
        const extractRcsTextFull = translationData => {
          let groupId = '',
            unitId = '',
            messageComponentId = ''
          let fallbackGroupId = '',
            fallbackUnitId = '',
            fallbackComponentId = ''
          let messageText = '',
            fallbackText = ''
          const actionButtonComponentIds = []
          const actionButtons = []

          translationData?.layoutGroups?.forEach(group => {
            group.contentUnits.forEach(unit => {
              unit.components.forEach(comp => {
                const en = comp.translations?.en

                // MESSAGE TEXT
                if (unit.unitName === 'Message Content' && comp.componentKey === 'rcs_message') {
                  groupId = group.groupId
                  unitId = unit.unitId
                  messageComponentId = comp.contentId
                  messageText = en || ''
                }

                // ACTION BUTTONS
                if (unit.unitName === 'Message Content' && comp.componentKey === 'rcs_action_button') {
                  actionButtonComponentIds.push(comp.contentId)

                  if (en?.type === 'quick_reply') {
                    actionButtons.push({
                      id: comp.contentId,
                      type: 'quick_reply',
                      text: en.title,
                      quickReplies: (en.payload || []).map(q => ({
                        id: crypto.randomUUID(),
                        text: q
                      }))
                    })
                  } else {
                    actionButtons.push({
                      id: comp.contentId,
                      type: en?.type,
                      text: en?.title,
                      value: en?.payload
                    })
                  }
                }

                // FALLBACK
                if (unit.unitName === 'Fallback' && comp.componentKey === 'rcs_fallback_sms_message') {
                  fallbackGroupId = group.groupId
                  fallbackUnitId = unit.unitId
                  fallbackComponentId = comp.contentId
                  fallbackText = en || ''
                }
              })
            })
          })

          return {
            ids: {
              groupId,
              unitId,
              messageComponentId,
              actionButtonComponentIds,
              fallbackGroupId,
              fallbackUnitId,
              fallbackComponentId
            },
            ui: {
              messageText,
              actionButtons,
              fallbackText
            }
          }
        }

        const { ids, ui } = extractRcsTextFull(translation)

        setApiId(prev => ({
          ...prev,
          rcs: {
            ...prev.rcs,
            text: ids
          }
        }))

        setRCSTemplateType('text')
        setRCSValue(ui.messageText)
        setTextActionButtons(ui.actionButtons)
        setSmsFallbackTextforRCS(ui.fallbackText)
      }
      if (translation?.configuration?.template_type === 'rich_card_stand_alone') {
        setRCSTemplateType('rich')

        const extractRcsStandaloneToUI = response => {
          const layoutGroup = response?.layoutGroups?.[0]
          const contentUnit = layoutGroup?.contentUnits?.[0]
          const components = contentUnit?.components || []

          // ----- UI DATA -----
          const card = {
            cardOrientation: layoutGroup?.configuration?.card_orientation || ' ',
            mediaHeight: layoutGroup?.configuration?.media_height || ' ',
            headerType: '',
            headerMediaFile: '',
            titleText: '',
            bodyText: '',
            actionButtons: []
          }

          // ----- ID STORAGE -----
          let mediaId = '',
            titleId = '',
            descId = ''
          const actionButtonIds = []

          components.forEach(comp => {
            const en = comp.translations?.en

            if (comp.componentKey === 'rcs_media') {
              card.headerType = en?.type || ' '
              card.headerMediaFile = en?.url || ' '
              mediaId = comp.contentId
            }

            if (comp.componentKey === 'rcs_card_title') {
              card.titleText = en || ' '
              titleId = comp.contentId
            }

            if (comp.componentKey === 'rcs_card_description') {
              card.bodyText = en || ' '
              descId = comp.contentId
            }

            if (comp.componentKey === 'rcs_action_button') {
              actionButtonIds.push(comp.contentId)
              if (en?.type === 'quick_reply') {
                card.actionButtons.push({
                  id: comp.contentId,
                  type: 'quick_reply',
                  text: en.title,
                  quickReplies: (en.payload || []).map(q => ({ id: crypto.randomUUID(), text: q }))
                })
              } else {
                card.actionButtons.push({
                  id: comp.contentId,
                  type: en?.type,
                  text: en?.title,
                  value: en?.payload
                })
              }
            }
          })

          // ----- Fallback -----
          const fallbackGroup = response?.layoutGroups?.find(g => g.contentUnits?.[0]?.unitName === 'Fallback')
          let fallbackText = ''
          let fallbackGroupId = '',
            fallbackUnitId = '',
            fallbackComponentId = ''
          if (fallbackGroup) {
            const fallbackUnit = fallbackGroup.contentUnits[0]
            const fallbackComp = fallbackUnit.components[0]
            fallbackText = fallbackComp?.translations?.en || ' '
            fallbackGroupId = fallbackGroup.groupId
            fallbackUnitId = fallbackUnit.unitId
            fallbackComponentId = fallbackComp?.contentId
          }

          return {
            card,
            ids: {
              groupId: layoutGroup?.groupId,
              unitId: contentUnit?.unitId,
              mediaId,
              titleId,
              descId,
              actionButtonIds
            },
            fallback: {
              text: fallbackText,
              groupId: fallbackGroupId,
              unitId: fallbackUnitId,
              componentId: fallbackComponentId
            }
          }
        }

        const { card: rcsCard, ids, fallback } = extractRcsStandaloneToUI(translation)

        setCards([rcsCard]) // standalone = 1 card only

        // Store IDs in state
        setApiId(prev => ({
          ...prev,
          rcs: {
            ...prev.rcs,
            standalone: {
              groupId: ids.groupId || '',
              unitId: ids.unitId || '',
              mediaComponentId: ids.mediaId || '',
              titleComponentId: ids.titleId || '',
              descComponentId: ids.descId || '',
              actionButtonIds: ids.actionButtonIds || [],
              fallback
            }
          }
        }))

        // Set fallback UI state
        setSmsFallbackTextforRCS(fallback.text || ' ')
      } else if (translation?.configuration?.template_type === 'rich_card_carousel') {
        setRCSTemplateType('rich_carousel')

        // -------------------------------
        // CARD EXTRACTION
        // -------------------------------
        const mapApiResponseToCards = apiResponse => {
          const carouselGroup = apiResponse?.layoutGroups?.[0]
          if (!carouselGroup) {
            return []
          }

          const carouselApiId = {
            groupId: carouselGroup.groupId,
            cardUnits: []
          }

          const carouselCards = carouselGroup.contentUnits.map(unit => {
            const card = {
              id: unit.unitId,
              unitName: unit.unitName,
              headerType: 'none',
              headerMediaFile: null,
              titleText: '',
              bodyText: '',
              actionButtons: [],
              cardOrientation: carouselGroup.configuration?.card_orientation || 'vertical',
              mediaHeight: carouselGroup.configuration?.media_height || 'medium',
              ids: {
                mediaId: null,
                titleId: null,
                descId: null,
                actionIds: []
              }
            }

            unit.components.forEach(component => {
              const en = component.translations?.en

              switch (component.componentKey) {
                case 'rcs_media':
                  card.headerType = en?.type || 'image'
                  card.headerMediaFile = en?.url || null
                  card.ids.mediaId = component.contentId
                  break

                case 'rcs_card_title':
                  card.titleText = en || ' '
                  card.ids.titleId = component.contentId
                  break

                case 'rcs_card_description':
                  card.bodyText = en || ' '
                  card.ids.descId = component.contentId
                  break

                case 'rcs_action_button':
                  card.actionButtons.push({
                    id: component.contentId,
                    type: en?.type,
                    text: en?.title,
                    value: en?.payload
                  })
                  card.ids.actionIds.push(component.contentId)
                  break

                default:
                  break
              }
            })

            carouselApiId.cardUnits.push({
              unitId: unit.unitId,
              mediaId: card.ids.mediaId,
              titleId: card.ids.titleId,
              descId: card.ids.descId,
              actionIds: card.ids.actionIds
            })

            return card
          })

          setApiId(prev => ({
            ...prev,
            rcs: {
              ...prev.rcs,
              carousel: carouselApiId
            }
          }))

          return carouselCards
        }

        // -------------------------------
        // FALLBACK EXTRACTION
        // -------------------------------
        const extractFallback = apiResponse => {
          const fallbackGroup = apiResponse.layoutGroups.find(g => g.contentUnits?.[0]?.unitName === 'Fallback')

          if (!fallbackGroup) {
            return
          }

          const fallbackUnit = fallbackGroup.contentUnits[0]
          const fallbackComponent = fallbackUnit.components[0]

          setSmsFallbackTextforRCS(fallbackComponent.translations?.en || ' ')

          setApiId(prev => ({
            ...prev,
            rcs: {
              ...prev.rcs,
              fallback: {
                groupId: fallbackGroup.groupId,
                unitId: fallbackUnit.unitId,
                contentId: fallbackComponent.contentId
              }
            }
          }))
        }

        const cardsData = mapApiResponseToCards(translation)
        extractFallback(translation)

        setCards(cardsData)
      }

      // setEditorID(translation?.editorId)
      setIsRCSContentModified(false)
      // setRCSTemplateContentId(translation?.templateChannelTranslationId)
    }
  }
  const updateChannelStates = channels => {
    setEnableEmail(
      channels?.some(channel => channel.channelName.toLowerCase() === 'email' && channel.recordStatus === 'active')
    )
    setEnableWhatsapp(
      channels?.some(channel => channel.channelName.toLowerCase() === 'whatsapp' && channel.recordStatus === 'active')
    )
    setEnableRCS(
      channels?.some(channel => channel.channelName.toLowerCase() === 'rcs' && channel.recordStatus === 'active')
    )
    setEnableSms(
      channels?.some(channel => channel.channelName.toLowerCase() === 'sms' && channel.recordStatus === 'active')
    )

    const emailChannel = channels?.find(
      channel => channel.channelName.toLowerCase() === 'email' && channel.recordStatus === 'active'
    )
    const whatsappChannel = channels?.find(
      channel => channel.channelName.toLowerCase() === 'whatsapp' && channel.recordStatus === 'active'
    )
    const rcsChannel = channels?.find(
      channel => channel.channelName.toLowerCase() === 'rcs' && channel.recordStatus === 'active'
    )
    const smsChannel = channels?.find(
      channel => channel.channelName.toLowerCase() === 'sms' && channel.recordStatus === 'active'
    )

    setEmailChannelId(emailChannel ? emailChannel.channelId : defaultProvider.emailChannelId)
    setWhatsappChannelId(whatsappChannel ? whatsappChannel.channelId : defaultProvider.whatsappChannelId)
    setRcsChannelId(rcsChannel ? rcsChannel.channelId : defaultProvider.rcsChannelId)
    setSmsChannelId(smsChannel ? smsChannel.channelId : defaultProvider.smsChannelId)

    setEmailTemplateChannelId(emailChannel ? emailChannel.templateChannelId : defaultProvider.emailTemplateChannelId)
    setWhatsappTemplateChannelId(
      whatsappChannel ? whatsappChannel.templateChannelId : defaultProvider.whatsappTemplateChannelId
    )
    setRcsTemplateChannelId(rcsChannel ? rcsChannel.templateChannelId : defaultProvider.rcsTemplateChannelId)
    setSmsTemplateChannelId(smsChannel ? smsChannel.templateChannelId : defaultProvider.smsTemplateChannelId)

    setPreviewEmailData(emailChannel ? emailChannel?.templateTranslation?.content : defaultProvider.previewEmailData)
    setPreviewWhatsappData(
      whatsappChannel ? whatsappChannel?.templateTranslation?.content : defaultProvider.previewWhatsappData
    )
    setPreviewSmsData(smsChannel ? smsChannel?.templateTranslation?.content : defaultProvider.previewSmsData)
    setEmailTemplateContentId(
      emailChannel
        ? emailChannel?.templateTranslation?.templateChannelTranslationId
        : defaultProvider.emailTemplateContentId
    )
    setWhatsappTemplateContentId(
      whatsappChannel
        ? whatsappChannel?.templateTranslation?.templateChannelTranslationId
        : defaultProvider.whatsappTemplateContentId
    )
    setRcsTemplateContentId(
      rcsChannel ? rcsChannel?.templateTranslation?.templateChannelTranslationId : defaultProvider.rcsTemplateContentId
    )
    setSmsTemplateContentId(
      smsChannel ? smsChannel?.templateTranslation?.templateChannelTranslationId : defaultProvider.smsTemplateContentId
    )
  }

  const sendTemplateMailToMailpit = async mailpitEmailValue => {
    try {
      const emailPayload = {
        Attachments: [],
        Bcc: [],
        Cc: [],
        From: {
          Email: 'Cxpify.com <noreply@cxpify.com>',
          Name: 'senderName'
        },
        HTML: mailpitEmailValue,
        Headers: {},
        ReplyTo: replyEmail
          ? [
              {
                Email: replyEmail,
                Name: 'senderName'
              }
            ]
          : [],
        Subject: 'TestSubject',
        Tags: [],
        Text: ''
      }
      const response = await api.post(sendMailToMailpit, emailPayload)
      setMailpitID(response?.data?.id)

      if (response?.status === 200) {
        return true
      }
      return false
    } catch {
      // errors are already shown by the api client's response interceptor
    }
  }

  const replaceTagsWithData = async channelContent => {
    try {
      const inputData = {
        content: channelContent
      }
      const response = await api.post(replaceMergeTags, inputData)
      const data = response?.data?.message
      return data
    } catch {
      // errors are already shown by the api client's response interceptor
    }
  }

  // Returns { success, message } rather than a bare boolean so callers that need the
  // actual failure reason (e.g. Submit for Approval reusing this same call) can show
  // it, while callers that only care whether it worked can just check `.success`.
  // `data` carries the raw response payload alongside success/message so a caller that
  // needs more than pass/fail - e.g. Submit for Approval reading a per-channel vendor
  // submission list - can inspect it, while callers that only check `.success` are
  // unaffected. CXP-side validation failures come back as a thrown 400; vendor-side
  // submission failures come back as a 200 (channels run in parallel, so some can
  // succeed while others fail) with the same `{ all_valid, results }` response shape
  // either way - so `data` is populated on both the success and catch paths.
  const updateTemplateStatus = async (templateId, templateStatus) => {
    try {
      const inputData = {
        templateStatus: templateStatus
      }
      const response = await api.put(`${templateUrl}/${templateId}/status`, inputData, { skipGlobalToast: true })
      const data = response?.data?.data
      if (!data) {
        const message = 'Failed to update the template status!'
        showError(message)
        return { success: false, message }
      }
      // else: status updated — no success toast per request
      return { success: true, data }
    } catch (error) {
      return {
        success: false,
        message:
          error?.response?.data?.message || error?.response?.data?.error || 'Failed to update the template status',
        data: error?.response?.data?.data || error?.response?.data
      }
    }
  }

  const generateAIContent = async (contentDescription, templateChannelId, channelId) => {
    try {
      if (emailValue || contentDescription) {
        const inputData = {
          email_body: emailValue,
          content_description: contentDescription
        }

        const queryParams = {
          channelId: channelId
        }
        const response = await api.post(`${generateSubjectUrl}/templates/${templateChannelId}`, inputData, {
          params: queryParams
        })
        showSuccess('Generated subjects successfully')
        const data = response?.data?.data
        return data
      } else {
        showWarning('Please enter content description or html')
      }
    } catch {
      // errors are already shown by the api client's response interceptor
    }
  }

  const getAIDescription = async (templateChannelId, channelId) => {
    try {
      const queryParams = {
        channelId: channelId
      }
      const response = await api.get(`${generateSubjectUrl}/templates/${templateChannelId}`, {
        params: queryParams
      })
      const data = response?.data?.data?.content_description
      return data
    } catch {
      // errors are already shown by the api client's response interceptor
    }
  }

  const generateAIImage = async (prompt, aspectRatio) => {
    const enhancedPrompt = `${prompt}. Generate at 1280x720 resolution, output as JPEG with quality 80.`
    const payload = {
      prompt: enhancedPrompt,
      aspect_ratio: aspectRatio
    }

    const response = await api.post(generateImageAIUrl, payload)

    if (response?.status === 200 || response?.status === 201) {
      showSuccess('Image generated successfully')

      return response?.data?.data || response?.data
    }

    return null
  }

  const getArchivedTemplateList = async (query = '') => {
    try {
      const queryParams = new URLSearchParams({
        recordStatus: 'archived'
      })

      if (query) {
        queryParams.append('query', query)
      }

      const response = await api.get(`${templateUrl}?${queryParams.toString()}`)

      setArchivedTemplateData(response?.data?.data ?? [])
    } catch {
      // errors are already shown by the api client's response interceptor
    }
  }

  const archivedTemplate = async (templateId, recordStatus) => {
    const payload = {
      templateStatus: recordStatus
    }
    const response = await api.put(`${templateUrl}/${templateId}/status`, payload)

    return response?.data
  }

  const getAllTags = async (query = '') => {
    try {
      const url = `${getTags}?query=${encodeURIComponent(query)}`
      const response = await api.get(url)
      setTagsData(response?.data?.Data || [])
    } catch {
      // errors are already shown by the api client's response interceptor
    }
  }

  const determineDefaultChannelStep = () => {
    if (templateDirection === 'f') {
      if (enableEmail) {
        return 1.1
      }
      if (enableWhatsapp) {
        return 1.2
      }
      if (enableSms) {
        return 1.3
      }
      if (enableRCS) {
        return 1.4
      }
    } else if (templateDirection === 'b') {
      if (enableRCS) {
        return 1.4
      }
      if (enableSms) {
        return 1.3
      }
      if (enableWhatsapp) {
        return 1.2
      }
      if (enableEmail) {
        return 1.1
      }
    }
    return 0
  }

  const resetTemplate = async () => {
    setSelectedTemplateId('')
    setSelectedChannels([])
    setTemplateName('')
    setTemplateDescription('')
    setTemplateLanguage('en')
    setTags([])
    setSelectedTemplate('')
    setEditorID(2)
    setSmsValue('')
    setEmailValue('')
    setMailpitID('')
    setWhatsappValue('')

    setExternalTemplateId('')
    setWhatsappExternalTemplateId('')
    setRcsExternalTemplateId('')
    setSmsExternalTemplateId('')
    // Reset WhatsApp builder state
    setTemplateCategory('marketing')
    setWhatsappSelectedVendor(null)
    setRcsSelectedVendor(null)
    setWhatsappHeaderType('none')
    setWhatsappHeaderText('')
    setWhatsappHeaderLink('')
    setWhatsappHeaderMediaFromPC('')
    setWhatsappHeaderMediaHeaderId('')
    setWhatsappFooterText('')
    setWhatsappButtons([])
    setUpdatedEnabledChannels([])
    setUpdatedDisabledChannels([])
    setIsTemplateChannelsModified(false)
    setIsTemplateSetupModified(false)
    setIsEmailContentModified(false)
    setIsWhatsappContentModified(false)
    setIsSmsContentModified(false)
    setIsRCSContentModified(false)
    setEmailValue('')
    setWhatsappValue('')
    setRCSValue('')
    setSmsValue('')
    setSmsFallbackTextforRCS('')
    setHtmlValue('')
    setBeeValue('')
    setSelectedTemplateChannelTab('')
    setEmailTemplateChannelId('')
    setWhatsappTemplateChannelId('')
    setRcsTemplateChannelId('')
    setSmsTemplateChannelId('')
    setEmailChannelId('')

    setWhatsappChannelId('')
    setRcsChannelId('')
    setSmsChannelId('')
    setEmailTemplateContentId('')
    setWhatsappTemplateContentId('')
    setRcsTemplateContentId('')
    setSmsTemplateContentId('')
    setBeefreeJSON('')
    setPreviewEmailData('')
    setPreviewWhatsappData('')
    setPreviewSmsData('')
    setPublishedTemplateList([])
    setTemplateValidationCheckList([])
    setIsTemplateValid(false)
    setTagsData([])
    setSubjectLine('')
    setPreheaderText('')
    setRCSTemplateType('text')
    setEmailValue('')
    ;(setStandaloneRcsCard({}), setSelectedVendorData({}), setCustomKeyValuePairs([]), setAttachments([]))
    setCardType('standard')
    setCards([
      {
        id: 1,
        headerType: 'none',
        headerMediaFile: null,
        titleText: '',
        bodyText: '',
        actionButtons: [],
        cardOrientation: 'vertical',
        mediaHeight: 'short'
      }
    ])
    setWhatsappCards([
      {
        id: 1,
        headerType: 'none',
        headerMediaFile: null,
        titleText: '',
        bodyText: '',
        actionButtons: [],
        cardOrientation: 'vertical',
        mediaHeight: 'short'
      }
    ])
    setTextActionButtons([])
    setWhatsappActionButtons([])
    setApiId({
      sms: {
        layoutGroupId: '',
        unitId: '',
        componentId: ''
      },

      rcs: {
        // text: {
        //   layoutGroupId: "",
        //   unitId: "",
        //   messageComponentId: "",
        //   actionButtonComponentIds: [] // dynamic array
        // },
        text: {
          groupId: '', // was layoutGroupId
          unitId: '',
          messageComponentId: '',
          actionButtonComponentIds: [],
          fallbackComponentId: ''
        },
        standalone: {
          layoutGroupId: '',
          unitId: '',
          mediaComponentId: '',
          titleComponentId: '',
          descComponentId: '',
          actionButtonIds: [] // array for button componentIds
        },

        carousel: {
          layoutGroupId: '',
          cardUnits: [
            // each card:
            // {
            //   unitId: "",
            //   mediaId: "",
            //   titleId: "",
            //   descId: "",
            //   actionIds: []
            // }
          ]
        }
      },

      whatsapp: {
        // standard: {
        //   layoutGroupId: "",
        //   headerId: "",
        //   bodyId: "",
        //   footerId: "",
        //   actionButtonIds: []
        // },
        standard: {
          // HEADER
          headerGroupId: '',
          headerUnitId: '',
          headerId: '',

          // BODY
          bodyGroupId: '',
          bodyUnitId: '',
          bodyId: '',

          // FOOTER (TEXT)
          footerGroupId: '',
          footerUnitId: '',
          footerId: '',

          // ACTION BUTTONS (Footer 2)
          actionGroupId: '', // groupId for the action footer group
          actionUnitId: '', // unitId for the action group
          actionButtonIds: [] // array of contentIds for each button
        },
        carousel: {
          // BODY BLOCK
          bodyGroupId: '', // layoutGroupId for body section
          bodyUnitId: '', // unitId of the body content
          bodyComponentId: '', // contentId for the body text

          // CARDS BLOCK
          cardsGroupId: '', // layoutGroupId for card list

          cards: [
            // Repeat for dynamic cards
            // This is ONE card structure:
            {
              unitId: '', // card unit ID
              headerId: '', // header component contentId
              bodyId: '', // body component contentId
              actionIds: [] // array of contentIds for actions
            }
          ]
        }

        // carousel: {
        //   body: {
        //     layoutGroupId: "",
        //     unitId: "",
        //     componentId: "" // whatsapp_body
        //   },

        //   cards: [
        //     // each card entry like:
        //     // {
        //     //   layoutGroupId: "",
        //     //   unitId: "",
        //     //   headerId: "",
        //     //   bodyId: "",
        //     //   footerId: "",
        //     //   actionIds: []
        //     // }
        //   ]
        // }
      },

      email: {
        header: {
          layoutGroupId: '',
          unitId: '',
          componentId: ''
        },
        body: {
          layoutGroupId: '',
          unitId: '',
          componentId: ''
        }
      }
    })
    setTemplateActiveStep(0)
  }

  const determineDefaultValue = () => {
    if (templateDirection === 'f') {
      if (enableEmail) {
        return 'email'
      }
      if (enableWhatsapp) {
        return 'whatsapp'
      }

      if (enableSms) {
        return 'sms'
      }
      if (enableRCS) {
        return 'rcs'
      }
    } else if (templateDirection === 'b') {
      if (enableRCS) {
        return 'rcs'
      }
      if (enableSms) {
        return 'sms'
      }

      if (enableWhatsapp) {
        return 'whatsapp'
      }
      if (enableEmail) {
        return 'email'
      }
    }
    return ''
  }
  const refreshExternalTemplateStatus = async templateId => {
    try {
      const response = await api.post(`${externalIdUrl}/refresh-status`, { templateId })
      if (response?.status === 200 || response?.status === 201) {
        return response?.data?.data
      }
      return null
    } catch {
      return null
    }
  }
  const getExternalTemplateDetails = async id => {
    try {
      const response = await api.get(`${externalIdUrl}/${id}/field-mapping`)
      if (response?.status === 200 || response?.status === 201) {
        const externalTemplateDetails = response?.data?.data

        return externalTemplateDetails
      }
    } catch {
      return false
    }
  }
  const fetchChannelVendors = async (channelId, filters = {}) => {
    if (!channelId) {
      return []
    }
    try {
      const response = await api.get(`${externalIdUrl}/vendors`, {
        params: {
          channelId,
          ...(filters.allowTemplateCreation && { allowTemplateCreation: true }),
          ...(filters.allowExternalTemplateLinking && { allowExternalTemplateLinking: true })
        }
      })

      return response?.data?.data || []
    } catch {
      return []
    }
  }

  const getVendorsList = async (channelId, filters = {}) => {
    const vendorList = await fetchChannelVendors(channelId, filters)
    setVendorListData(vendorList)

    return vendorList.length > 0
  }
  const getVendorMasterVariableList = async (channelId, vendorId) => {
    const inputData = {
      channel_id: channelId,
      vendor_id: vendorId
    }
    try {
      const response = await api.post(`${externalIdUrl}/vendor-template-variables/channel`, inputData)
      if (response?.status === 200 || response?.status === 201) {
        return response?.data?.data
      }
    } catch {
      return false
    }
  }
  const createVendorTemplateVariables = async payload => {
    try {
      const response = await api.post(`${externalIdUrl}/vendor-master-template-variable-list`, payload)

      showSuccess('Vendor master template variable list updated successfully')
      return response?.status === 200
    } catch {
      // errors are already shown by the api client's response interceptor
    }
  }
  const searchVendorsTemplates = async (channelId, payloadData) => {
    try {
      const response = await api.post(`${externalIdUrl}/search`, payloadData)

      return response?.data
    } catch {
      // optional: return null instead of false (cleaner handling)
      return null
    }
  }
  const updateMappingExtTemplates = async (mappingPayload, channelType) => {
    try {
      const response = await api.put(`${externalIdUrl}/mappings`, mappingPayload)
      if (response?.status === 200 || response?.status === 201) {
        const dataId = response?.data?.data?.Data?.externalTemplateID
        if (channelType === 'whatsapp') {
          setWhatsappExternalTemplateId(dataId)
          setIsWhatsappContentModified(false)
        } else if (channelType === 'sms') {
          setSmsExternalTemplateId(dataId)
          setIsSmsContentModified(false)
        } else if (channelType === 'rcs') {
          setRcsExternalTemplateId(dataId)
          setIsRCSContentModified(false)
        }

        return true
      }
    } catch {
      return false
    }
  }

  // Reusable across WhatsApp, RCS and SMS: called after a user confirms mapping an
  // external template onto a channel. Replaces the channel's current content with the
  // mapped data.
  const mapTemplateChannelData = async (channelId, payload = {}) => {
    try {
      const response = await api.delete(`${templateUrl}/${selectedTemplate?.id}/channeldata/${channelId}`, {
        // skipGlobalToast: true
      })
      if (response?.status === 200 || response?.status === 201) {
        //  showSuccess('Channel data mapped successfully')
        return true
      }
      return false
    } catch (error) {
      //  showError(error?.response?.data?.message || error?.response?.data?.error || 'Failed to map channel data')
      return false
    }
  }

  const unLinkExtTemplates = async (channelId, extTemplateId) => {
    try {
      const inputData = {
        template_channel_id: channelId,
        external_template_id: extTemplateId
      }

      const response = await api.put(`${externalIdUrl}/unlink`, inputData)
      if (response?.status === 200 || response?.status === 201) {
        showSuccess(response?.data?.data?.Data)
        return true
      }
    } catch {
      return false
    }
  }

  const values = useMemo(() => ({
    previewEmailData,
    setPreviewEmailData,
    previewWhatsappData,
    setPreviewWhatsappData,
    previewSmsData,
    setPreviewSmsData,
    beefreeJSON,
    setBeefreeJSON,
    selectedChannelId,
    setSelectedChannelId,
    htmlValue,
    setHtmlValue,
    beeValue,
    setBeeValue,
    smsValue,
    setSmsValue,
    smsFallbackTextforRCS,
    setSmsFallbackTextforRCS,
    emailValue,
    setEmailValue,
    whatsappValue,
    setWhatsappValue,
    // WhatsApp builder state
    templateCategory,
    setTemplateCategory,
    whatsappSelectedVendor,
    setWhatsappSelectedVendor,
    rcsSelectedVendor,
    setRcsSelectedVendor,
    whatsappHeaderType,
    setWhatsappHeaderType,
    whatsappHeaderText,
    setWhatsappHeaderText,
    whatsappHeaderLink,
    setWhatsappHeaderLink,
    whatsappHeaderMediaFromPC,
    setWhatsappHeaderMediaFromPC,
    whatsappHeaderMediaHeaderId,
    setWhatsappHeaderMediaHeaderId,
    whatsappFooterText,
    setWhatsappFooterText,
    whatsappButtons,
    setWhatsappButtons,
    rcsValue,
    setRCSValue,
    previousUserChannels,
    setPreviousUserChannels,
    enableEmail,
    setEnableEmail,
    enableWhatsapp,
    setEnableWhatsapp,
    enableRCS,
    setEnableRCS,
    enableSms,
    setEnableSms,
    isEmailContentModified,
    setIsEmailContentModified,
    isRCSContentModified,
    setIsRCSContentModified,
    isWhatsappContentModified,
    setIsWhatsappContentModified,
    isSmsContentModified,
    setIsSmsContentModified,
    selectedTemplateId,
    setSelectedTemplateId,
    externalTemplateId,
    setExternalTemplateId,
    externalTemplateKey,
    setExternalTemplateKey,
    whatsappExternalTemplateId,
    setWhatsappExternalTemplateId,
    smsExternalTemplateId,
    setSmsExternalTemplateId,
    rcsExternalTemplateId,
    setRcsExternalTemplateId,
    whatsappExternalTemplateKey,
    setWhatsappExternalTemplateKey,
    smsExternalTemplateKey,
    setSmsExternalTemplateKey,
    rcsExternalTemplateKey,
    setRcsExternalTemplateKey,

    selectedTemplateChannelId,
    setSelectedTemplateChannelId,
    isTemplateSetupModified,
    setIsTemplateSetupModified,
    templateSaveStatus,
    setTemplateSaveStatus,
    selectedChannels,
    setSelectedChannels,
    tags,
    setTags,
    activeChannelStep,
    setActiveChannelStep,
    templateName,
    setTemplateName,
    templateDescription,
    setTemplateDescription,
    templateLanguage,
    setTemplateLanguage,
    templateListData,
    setTemplateListData,
    vendorListData,
    setVendorListData,
    isApiIntegrated,
    setIsApiIntegrated,
    selectedTemplateChannelTab,
    setSelectedTemplateChannelTab,
    templateDirection,
    setTemplateDirection,
    editorID,
    setEditorID,
    isTemplateChannelsModified,
    setIsTemplateChannelsModified,
    updatedEnabledChannels,
    setUpdatedEnabledChannels,
    updatedDisabledChannels,
    setUpdatedDisabledChannels,
    searchTerm,
    setSearchTerm,
    isProcessing,
    setIsProcessing,
    isNextStepLoading,
    setIsNextStepLoading,
    getWhatsappPayload,

    validateTemplatePayload: validateTemplatePayload,
    determineDefaultValue: determineDefaultValue,
    determineDefaultChannelStep: determineDefaultChannelStep,
    sendTemplateMailToMailpit: sendTemplateMailToMailpit,
    getTemplateList: getTemplateList,
    getTemplateFilterList: getTemplateFilterList,
    updateTemplateStatus: updateTemplateStatus,
    getAIDescription: getAIDescription,
    replaceTagsWithData: replaceTagsWithData,
    getPublishedTemplateList: getPublishedTemplateList,
    getTemplate: getTemplate,
    getTemplateWithCampaigns,
    validateTemplate: validateTemplate,
    updateIgnoredValidations: updateIgnoredValidations,
    createTemplate: createTemplate,
    updateTemplate: updateTemplate,
    enableTemplateChannels: enableTemplateChannels,
    disableTemplateChannels: disableTemplateChannels,
    resetTemplate: resetTemplate,
    deleteTemplate: deleteTemplate,
    UpsertEmailChannelTranslation: UpsertEmailChannelTranslation,
    UpsertWhatsappChannelTranslation: UpsertWhatsappChannelTranslation,
    UpsertRCSChannelTranslation: UpsertRCSChannelTranslation,
    UpsertSMSChannelTranslation: UpsertSMSChannelTranslation,
    GetTemplateChannelTranslation: GetTemplateChannelTranslation,
    fetchEmailTranslation: fetchEmailTranslation,
    fetchWhatsappTranslation: fetchWhatsappTranslation,
    fetchSMSTranslation: fetchSMSTranslation,
    fetchRCSTranslation: fetchRCSTranslation,
    cloneTemplate: cloneTemplate,
    generateAIContent: generateAIContent,
    generateAIImage: generateAIImage,
    publishedTemplateList,
    setPublishedTemplateList,
    setWhatsappContentDescription,
    smsContentDescription,
    setSmsContentDescription,
    emailTemplateChannelId,
    setEmailTemplateChannelId,
    whatsappTemplateChannelId,
    setWhatsappTemplateChannelId,
    rcsTemplateChannelId,
    setRcsTemplateChannelId,
    smsTemplateChannelId,
    setSmsTemplateChannelId,
    emailChannelId,
    setEmailChannelId,
    whatsappChannelId,
    setWhatsappChannelId,
    rcsChannelId,
    setRcsChannelId,
    smsChannelId,
    setSmsChannelId,
    selectedTemplate,
    setSelectedTemplate,
    mailpitID,
    setMailpitID,
    templateValidationCheckList,
    setTemplateValidationCheckList,
    isTemplateValid,
    setIsTemplateValid,
    archivedTemplateData,
    setArchivedTemplateData,
    emailTemplateContentId,
    setEmailTemplateContentId,
    whatsappTemplateContentId,
    setWhatsappTemplateContentId,
    smsTemplateContentId,
    setSmsTemplateContentId,
    getArchivedTemplateList: getArchivedTemplateList,
    archivedTemplate: archivedTemplate,
    totalTemplates,
    setTotalTemplates,
    getAllTags: getAllTags,
    tagsData,
    setTagsData,
    selectedPreviewTab,
    setSelectedPreviewTab,
    activePreviewStep,
    setActivePreviewStep,
    subjectLine,
    setSubjectLine,
    preheaderText,
    setPreheaderText,
    getEmailPayload: getEmailPayload,
    templatesTagList,
    setTemplatesTagList,
    templatesChannelFilterList,
    setTemplatesChannelFilterList,
    customKeyValuePairs,
    setCustomKeyValuePairs,
    attachments,
    setAttachments,
    templatesStatusFilterList,
    setTemplatesStatusFilterList,
    cards,
    setCards,
    templateBulkAction,
    getSmsPayload: getSmsPayload,
    getRcsStandalonePayload: getRcsStandalonePayload,
    getRcsCarouselPayload: getRcsCarouselPayload,
    rcstemplateType,
    setRCSTemplateType,
    getRcsTextPayload: getRcsTextPayload,
    getActionButtonPayload: getActionButtonPayload,
    getRCSPayload: getRCSPayload,
    setWhatsappCards,
    whatsappCards,
    cardType,
    setCardType,
    // buildActionButtonPayload: buildActionButtonPayload,
    textActionButtons,
    setTextActionButtons,
    whatsappActionButtons,
    setWhatsappActionButtons,
    apiId,
    setApiId,
    standaloneRcsCard,
    setStandaloneRcsCard,
    selectedVendorData,
    setSelectedVendorData,
    setWhatsappHeaderFile,
    whatsappHeaderFile,
    templateFilterList,
    setTemplateFilterList,
    templateOtherFilterList,
    setTemplateOtherFilterList,
    hasTagFilter,
    setHasTagFilter,
    getCheckUsageTemplates,
    isFooterOpen,
    setIsFooterOpen,
    getVendorsList: getVendorsList,
    fetchChannelVendors: fetchChannelVendors,
    searchVendorsTemplates: searchVendorsTemplates,
    updateMappingExtTemplates: updateMappingExtTemplates,
    mapTemplateChannelData: mapTemplateChannelData,
    unLinkExtTemplates: unLinkExtTemplates,
    getExternalTemplateDetails: getExternalTemplateDetails,
    refreshExternalTemplateStatus: refreshExternalTemplateStatus,
    getVendorMasterVariableList,
    templateActiveStep,
    setTemplateActiveStep,
    createVendorTemplateVariables
  }))
  return <TemplateContext.Provider value={values}>{children}</TemplateContext.Provider>
}
TemplateProvider.propTypes = {
  children: PropTypes.node.isRequired
}

export { TemplateContext, TemplateProvider }
